<template>
  <div class="image-container set-full-height">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-bottom: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red">กลับสู่หน้า Home</button>
        </div>

        <div class="col-sm-8 col-sm-offset-2" align="center" style="margin-bottom: 25px">
          <button class="btn btn-danger" @click="SwitchMenu('0')" style="color: #eea236;margin: 15px">
            จัดการข้อมูลบัตร
          </button>
          <button class="btn btn-danger" @click="SwitchMenu('1')" style="color: #eea236;margin: 15px">
            เพิ่มประเภทร้านค้า
          </button>
          <button class="btn btn-danger" @click="SwitchMenu('2')" style="color: #eea236;margin: 15px">
            เพิ่มประเภทความสัมพันธ์
          </button>
          <button class="btn btn-danger" v-if="CheckPermissMenu()" @click="SwitchMenu('3')" style="color: #eea236;margin: 15px">
            เพิ่มสิทธิ์การเข้าทำบัตรญาติ
          </button>
          <button class="btn btn-danger" v-if="CheckPermissMenu()" @click="dialogCondition = true" style="color: #eea236;margin: 15px">
            กำหนดเงื่อนไขการทำบัตร
          </button>
        </div>

        <div class="col-sm-8 col-sm-offset-2" align="center" style="margin-bottom: 25px"
             v-if="manageMenu == '0'">
          <v-list-item class="d-flex justify-center">
            <v-radio-group v-model="rdoCardType" row @change="ChooseCardType">
              <v-radio label="บัตรญาติ" value="2">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountType2.length }}
              </v-chip>
              <v-radio label="บัตรผู้ประกอบการ" value="4" class="ml-2">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountType4.length }}
              </v-chip>
              <v-radio label="ทั้งหมด" value="0" class="ml-2">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountTypeAll }}
              </v-chip>
            </v-radio-group>
          </v-list-item>
          <v-card v-if="rdoCardType == '2' || rdoCardType == '4'">
            <v-card-title>
              filter Data
            </v-card-title>
            <v-radio-group v-model="rdoCardType2" row @change="ChooseCardType2">
              <v-radio label="ยื่นขออนุมัติ" value="0">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountTypeSec0.length }}
              </v-chip>
              <v-radio label="แก้ไข" value="6">
              </v-radio>
              <v-chip color="#9E9D24" dark>
                {{ CountTypeSec6.length }}
              </v-chip>
              <v-radio label="อนุมัติ" value="2" class="ml-2">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountTypeSec2.length }}
              </v-chip>
              <v-radio label="ไม่อนุมัติ" value="3" class="ml-2">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountTypeSec3.length }}
              </v-chip>
              <v-radio label="พิมพ์บัตร" value="4" class="ml-2">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountTypeSec4.length }}
              </v-chip>
              <v-radio label="จ่ายบัตร" value="5" class="ml-2">
              </v-radio>
              <v-chip color="green" dark>
                {{ CountTypeSec5.length }}
              </v-chip>
              <v-radio label="ทั้งหมด" value="*" class="ml-2">
              </v-radio>
              <v-chip color="green" dark>
                <span v-if="rdoCardType == '2'">{{ CountType2.length }}</span>
                <span v-else-if="rdoCardType == '4'">{{ CountType4.length }}</span>
              </v-chip>
            </v-radio-group>
          </v-card>
        </div>

        <div class="col-12" :style="backGround" v-if="manageMenu == '0'">

          <h3 align="center" style="color:#000; font-family:Prompt">ระบบทำบัตรออนไลน์ คณะแพทยศาสตร์
            ม.สงขลานครินทร์&nbsp;&nbsp;<a href="index.html" style="color:#000"><i class="ti-home"></i></a>
          </h3>
          <!--      Wizard container        -->
          <transition name="slide-fade">
            <div class="wizard-container" v-show="!ShowDetails">

              <div class="card wizard-card" data-color="orange" id="wizardProfile">
                <div action="" method="">
                  <!--        You can switch " data-color="orange" "  with one of the next bright colors: "blue", "green", "orange", "red", "azure"          -->

                  <div class="wizard-header text-center">
                    <div align="right" style="">{{ nameAdmin }} {{ surnameAdmin }} {{ depart }}
                    </div>
                    <div class="row" style="margin-top:-20px;">
                      <div class="col-12">
                        <h4 style="color:#000; font-family:Prompt"><u>ข้อมูลการขอทำบัตร</u>
                        </h4>
                          <v-row
                              v-scroll:#scroll-target="onScroll"
                              align="center"
                              justify="center"
                              style="height: 100%"
                          >
                            <v-card>
                              <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="ค้นหา"
                                    single-line
                                    hide-details
                                ></v-text-field>
                              </v-card-title>
                              <v-data-table
                                  :headers="columns"
                                  :items="rows"
                                  item-key="name"
                                  class="elevation-1"
                                  :search="search"
                                  style="width: 100%"
                              >
                                <template v-slot:item.url_display="{ item }">
                                  <img :src="ConnectionName + '/rest/files/' + item.url_display"
                                       width="130"
                                       height="150">
                                </template>
                                <template v-slot:item.Type="{item}">
                                  <td style="color:#000; font-family:Prompt; font-size:12px;"
                                      align="left">{{ item.Type }}
                                  </td>
                                </template>
                                <template v-slot:item.FullName="{ item }">
                                  <td style="color:#000; font-family:Prompt; font-size:12px;"
                                      align="left">
                                    <div v-html="item.FullName"></div>
                                    <v-btn text color="primary" @click="ShowCardAll(item)" v-if="item.Type == 'ญาติ' || item.Type == 'ผู้ประกอบการ,ร้านค้า'">
                                      <span style="font-size: 10px">ประวัติทำรายการ</span>
                                    </v-btn>
                                  </td>
                                </template>
                                <template v-slot:item.CardRequest="{ item }">
                                  <v-chip color="#00bbff"
                                          v-if="item.request_wish_id == '1'">
                                    {{ item.CardRequest }}
                                  </v-chip>
                                  <v-chip color="#985f0d"
                                          v-if="item.request_wish_id == '2'">
                                    {{ item.CardRequest }}
                                  </v-chip>
                                  <v-chip color="#EA80FC"
                                          v-if="item.request_wish_id == '4'">
                                    {{ item.CardRequest }}
                                  </v-chip>
                                </template>
                                <template v-slot:item.LicensePlate="{ item }">
                                                            <span v-if="item.license_plate != ''"
                                                                  style="color:#000; font-family:Prompt; font-size:12px;"
                                                                  align="left">{{ item.LicensePlate }}
                                                            </span>
                                </template>
                                <template v-slot:item.DateShow="{ item }">
                                  <td style="color:#000; font-family:Prompt; font-size:12px;"
                                      align="left">{{ item.DateShow }}
                                  </td>
                                </template>
                                <template v-slot:item.status_name="{ item }">
                                  <td style="color:blue; font-family:Prompt; font-size:12px;"
                                      align="left"
                                      v-if="item.status_id == '1' || item.status_id == '0'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:#3c763d; font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '2'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:rgba(185,11,19,0.99); font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '3'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:#5e5e5e; font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '4'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:rgba(148,24,185,0.99); font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '5'">
                                    {{ item.status_name }}
                                  </td>
                                  <td style="color:#afb42b; font-family:Prompt; font-size:12px;"
                                      align="left" v-if="item.status_id == '6'">
                                    {{ item.status_name }}
                                  </td>
                                </template>
                                <template v-slot:item.action="{ item }">
                                  <v-list-item class="justify-center">
                                    <v-btn outlined color="green"
                                           @click="showDetailsFunc(item)">รายละเอียด
                                    </v-btn>
                                  </v-list-item>
                                  <v-list-item class="justify-center">
                                    <v-btn outlined color="red"
                                           @click="DeleteCardItem(item)">ลบ
                                    </v-btn>
                                  </v-list-item>
                                </template>
                                <template v-slot:expanded-item="{ columns, item }">
                                  <td :colspan="5">More info about {{ item.id }}</td>
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <transition name="slide-fade2">
            <div class="wizard-container" v-if="ShowDetails">
              <div class="card wizard-card" data-color="red" id="wizard" v-if="showPage === '2'">
                <div>

                  <div class="wizard-header">
                    <h3 class="wizard-title" style="color:#000; font-family:Prompt"><u>ข้อมูลรายละเอียดขอทำบัตรสำหรับญาติบุคลากร</u>
                    </h3>
                    <p class="category">====================================</p>
                  </div>

                  <div align="left" style="margin-left: 30px">
                    <button class="btn btn-warning" @click="showDetailsFunc">
                      ย้อนกลับ
                    </button>
                  </div>

                  <div class="row">
                    <div class="col-sm-12"><br>

                      <h5 class="info-text"
                          style="font-family:Prompt; text-align:center;background-color:#fc8006;color:#fff">
                        &nbsp;&nbsp;ตัวอย่างบัตร</h5>
                    </div>

                    <div class="col-sm-6" style="margin-top: 15px;height: fit-content;width: 100%"
                         align="center"
                         v-if="nameTh != ''">
                      <div class="form-group"
                           style="text-align:center;height: 435px;width: fit-content">
                        <img src="../assets/img/c1.jpg" width="278" height="440">
                        <div
                            style="top: -164px;position: relative;left: 48px;width: 192px;font-weight: bold;font-size: 16px;text-align: center"
                            align="right">
                          <span>{{ nameTh }} {{ surnameTh }}</span>
                        </div>
                        <div
                            style="top: -134px;position: relative;left: 119px;width: 162px;font-weight: bold;font-size: 16px;text-align: left"
                            align="right">
                          <span>{{ perid }}</span>
                        </div>
                        <div
                            style="top: -132px;position: relative;left: 119px;width: 162px;font-weight: bold;font-size: 17px;text-align:left"
                            align="right">
                          <span>{{ namePerson.split(' ')[1] }} {{ namePerson.split(' ')[2] }}</span>
                        </div>
                        <img :src="ImagePerson" width="130" height="150"
                             style="position: relative;top: -395px;left: 5px;object-fit: contain;">
                        <div
                            style="top: -278px;position: relative;left: 119px;width: 162px;font-weight: bold;font-size: 17px;text-align:left"
                            align="right">
                          <span>{{ DateExpire | DateToThaiManageCard }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6" style="margin-top: 15px;width: 100%" align="center"
                         v-if="nameTh != ''">
                      <div class="form-group" style="text-align:center">
                        <img src="../assets/img/c2.jpg" width="278" height="440">

                      </div>
                    </div>

                  </div>

                  <div class="tab-content">
                    <div class="row">
                      <div class="col-sm-12"><br>

                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:center;background-color:#fc8006; color:#fff">
                          &nbsp;&nbsp;1. ข้อมูลส่วนตัว(ญาติ)</h5>
                      </div>

                      <div class="col-sm-5 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="ชื่อ(ภาษาไทย)" outlined
                                        v-model="nameTh"></v-text-field>
                        </div>
                      </div>
                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-text-field label="นามสกุล(ภาษาไทย)" outlined
                                        v-model="surnameTh"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-text-field label="เลขที่บัตรประชาชน" outlined
                                        v-model="idcard"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-text-field type="date" label="วัน/เดือน/ปี เกิด" outlined
                                        v-model="brithDay"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-select :items="genderOption" item-value="option"
                                    item-text="option" label="เพศ" outlined
                                    v-model="gender"></v-select>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-text-field label="โทรศัพท์เคลื่อนที่" outlined
                                        v-model="phoneMoblie"></v-text-field>
                        </div>
                      </div>


                      <div class="col-sm-5 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="โทรศัพท์บ้าน" outlined
                                        v-model="phoneHome"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-text-field label="อีเมลล์" outlined
                                        v-model="email"></v-text-field>
                        </div>
                      </div>


                      <div class="col-sm-10 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="ทีอยู่สามารถติดต่อได้" outlined
                                        v-model="address"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-10 col-sm-offset-1">
                        <p style="color: #761c19;font-weight: bold">กรณีต้องการเปิดสิทธิ์ไม้กั้น
                          ให้กับญาติกรุณากรอกข้อมูลด้านล่าง</p>
                      </div>
                      <div class="col-sm-5 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="ทะเบียนรถ" outlined
                                        v-model="vehicleReg"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-autocomplete outlined label="จังหวัด" :items="ProviceData"
                                          item-value="id"
                                          item-text="name_in_thai"
                                          v-model="vehicleRegProvice"></v-autocomplete>
                        </div>
                      </div>

                      <div class="col-sm-12">
                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:center;background-color:#fc8006;color:#fff">
                          &nbsp;&nbsp;2. ข้อมูลที่พักบุคลากร(ภายในคณะแพทยศาสตร์)</h5>
                      </div>

                      <div class="col-sm-5 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="หอพัก" outlined v-model="dorm"
                                        disabled></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-text-field label="ห้องพัก" outlined v-model="dorm2"
                                        disabled></v-text-field>
                        </div>
                      </div>
                      <div class="col-sm-12" align="center">
                        <v-btn outlined @click="GetDormHis">ประวัติหอพัก</v-btn>
                      </div>

                      <div class="col-sm-12" align="center" v-if="dormData.length > 0">
                        <v-data-table
                            :headers="dormHeader"
                            :items="dormData"
                            :items-per-page="5"
                            class="elevation-1"
                        >
                          <template v-slot:item.stay_in_date="{item}">
                            {{ item.stay_in_date | DateDMY }}
                          </template>
                          <template v-slot:item.active="{item}">
                                  <span v-if="item.active == '1'" style="font-weight: bold;color: #66afe9">
                                            ใช้งาน
                                        </span>
                            <span v-else style="font-weight: bold;color: #d9534f">
                                     -
                                </span>
                          </template>
                        </v-data-table>
                      </div>

                      <div class="col-sm-12"><br>

                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:center;background-color:#fc8006;color:#fff">
                          &nbsp;&nbsp;หลักฐานประกอบการทำบัตรญาติ</h5>
                      </div>

                      <div class="col-sm-10 col-sm-offset-1" align="center">
                        <div class="form-group">
                          <label>1) รูปถ่าย ขนาด 1 นิ้ว (หน้าตรง ไม่สวมหมวก
                            ไม่สวมแว่นดำ)</label>
                        </div>
                        <img v-if="ImagePersonType" :src="ImagePerson"
                             class="img-responsive"
                             style="cursor: pointer"
                             @click="ShowData(ImagePerson)"/>
                        <iframe v-else-if="pdfPersonType" :src="ImagePerson"
                                style="width:400px; height:300px;"
                                frameborder="0" @click="ShowData(ImagePerson)"></iframe>
                        <v-card v-else>
                          <v-alert
                              dense
                              outlined
                              type="error"
                          >
                            ไม่พบข้อมูลรูปถ่าย
                          </v-alert>
                        </v-card>
                        <div v-if="ImagePersonType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePerson)">เปิดรูป
                          </button>

                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('1')">ลบไฟล์
                          </button>
                        </div>
                        <div v-else-if="pdfPersonType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePerson)">เปิด PDF
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('1')">ลบไฟล์
                          </button>
                        </div>
                        <v-list-item>
                          <v-spacer></v-spacer>
                          <v-checkbox v-model="ChkImagePerson" label="แก้ไขรูปภาพ"
                                      color="yellow" @change="EditImagePerson"
                                      class="justify-center"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-list-item>
                        <div class="col-sm-12" align="center" v-if="ChkImagePerson">
                          <p style="font-family:Prompt;color: black;font-weight: bold">
                            เลือกตำแหน่งรูปภาพ</p>
                          <div style="border: 2px solid;border-color: #327339;padding: 10px">
                            <div class="cropper-wrapper" style="width: 100%;">
                              <div :style="{backgroundImage: 'url(' + pic_Profile + ')'}"
                                   class="cropper-background"></div>
                              <Cropper
                                  :src="pic_Profile"
                                  :restrictions="pixelsRestriction"
                                  @change="onChangePic"
                              />
                            </div>
                            <button class="btn btn-warning" @click="rotate"
                                    style="margin-top: 15px">
                              ** หมุนรูปภาพ **
                            </button>
                          </div>

                        </div>
                        <input type="file" class="form-control" id="pic"
                               placeholder="" style="background-color:#f8e1cb;margin-top: 30px"
                               @change="onFileSelected" v-if="ChkImagePerson">
                      </div>


                      <div class="col-sm-10 col-sm-offset-1" align="center"
                           style="margin-top: 20px">
                        <div class="form-group">
                          <label>2) สำเนาบัตรประจำตัวประชาชน</label>
                        </div>
                        <img v-if="ImagePersonCopyType" :src="ImagePersonCopy"
                             class="img-responsive"
                             style="cursor: pointer"
                             @click="ShowData(ImagePersonCopy)"/>
                        <iframe v-else-if="pdfPersonCopyType" :src="ImagePersonCopy"
                                style="width:400px; height:300px;" frameborder="0"
                                @click="ShowData(ImagePersonCopy)"></iframe>
                        <v-card v-else>
                          <v-alert
                              dense
                              outlined
                              type="error"
                          >
                            ไม่พบข้อมูลสำเนาบัตรประจำตัวประชาชน
                          </v-alert>
                        </v-card>
                        <div v-if="ImagePersonCopyType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePersonCopy)">เปิดรูป
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('2')">ลบไฟล์
                          </button>
                        </div>
                        <div v-else-if="pdfPersonCopyType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePersonCopy)">เปิด PDF
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('2')">ลบไฟล์
                          </button>
                        </div>
                        <v-list-item>
                          <v-spacer></v-spacer>
                          <v-checkbox v-model="ChkImagePersonCopy"
                                      label="แก้ไขสำเนาบัตรประจำตัวประชาชน" color="yellow"
                                      class="justify-center"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-list-item>
                        <input type="file" class="form-control" id="pic2"
                               placeholder="" style="background-color:#f8e1cb;margin-top: 30px"
                               @change="FileSelectPersonal" v-if="ChkImagePersonCopy">
                        <v-divider></v-divider>
                      </div>


                      <div class="col-sm-10 col-sm-offset-1" align="center"
                           style="margin-top: 20px">
                        <div class="form-group">
                          <label>3) ใบเสร็จรับเงิน งานคลัง คณะแพทยศาสตร์</label>
                        </div>
                        <img v-if="ImageRecriptType" :src="ImageRecript"
                             class="img-responsive"
                             style="cursor: pointer"
                             @click="ShowData(ImageRecript)"/>
                        <iframe v-else-if="pdfRecriptType" :src="ImageRecript"
                                style="width:400px; height:300px;" frameborder="0"
                                @click="ShowData(ImageRecript)"></iframe>
                        <v-card v-else>
                          <v-alert
                              dense
                              outlined
                              type="error"
                          >
                            ไม่พบข้อมูลใบเสร็จรับเงิน
                          </v-alert>
                        </v-card>
                        <div v-if="ImageRecriptType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImageRecript)">เปิดรูป
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('3')">ลบไฟล์
                          </button>
                        </div>
                        <div v-else-if="pdfRecriptType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImageRecript)">เปิด PDF
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('3')">ลบไฟล์
                          </button>
                        </div>
                        <v-list-item>
                          <v-spacer></v-spacer>
                          <v-checkbox v-model="ChkImageRecript" label="แก้ไขใบเสร็จรับเงิน"
                                      color="yellow" class="justify-center"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-list-item>
                        <v-list-item class="d-flex" v-if="RecriptData.length == 0">
                          <v-text-field type="number" outlined label="เลขที่ใบเสร็จ"
                                        class="ma-2" v-model="recript1"></v-text-field>
                          <span style="font-weight: bold;transform: scale(2)" class="mb-6">-</span>
                          <v-text-field type="number" outlined label="เลขที่ใบเสร็จ"
                                        class="ma-2" v-model="recript2"></v-text-field>
                        </v-list-item>
                        <v-list-item>
                          <v-text-field type="date" outlined label="วันที่ออกใบเสร็จ"
                                        class="ma-2" v-model="date" v-if="RecriptData.length == 0"></v-text-field>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="RecriptData.length == 0">
                          <v-textarea outlined label="หมายเหตุ (ถ้ามี)" v-model="remark"></v-textarea>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="RecriptData.length == 0">
                          <v-btn outlined color="pink" class="darken-4 ma-4" @click="ReCheckDupeRecript">ตรวจสอบ</v-btn>
                          <v-btn outlined color="primary" class="darken-4 ma-4" @click="saveRecript">บันทึก</v-btn>
                        </v-list-item>
                        <v-list-item v-if="CheckRecript">
                          <v-alert
                              style="width: 100%"
                              class="d-block"
                              dense
                              outlined
                              type="success"
                              v-if="ReCheckRecript.length == 0"
                          >
                            ไม่พบข้อมูลใบเสร็จซํ้า
                          </v-alert>
                          <v-alert
                              style="width: 100%"
                              class="d-block"
                              dense
                              outlined
                              type="error"
                              v-else
                          >
                            พบรายการใบเสร็จซํ้าโปรดตรวจสอบ
                          </v-alert>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="RecriptData.length > 0">
                          <v-data-table :headers="RecriptHeader" :items="RecriptData">
                            <template v-slot:item.recript_no="props">
                              <v-edit-dialog
                                  :return-value.sync="props.item.recript_no"
                                  @save="save(props.item)"
                                  @cancel="cancel"
                                  @open="open"
                                  @close="close"
                              >
                                {{ props.item.recript_no }}
                                <template v-slot:input>
                                  <v-text-field
                                      v-model="props.item.recript_no"
                                      label="Edit"
                                      single-line
                                      counter
                                  ></v-text-field>
                                </template>
                              </v-edit-dialog>
                            </template>
                            <template v-slot:item.date="props">
                              <v-edit-dialog
                                  :return-value.sync="props.item.date"
                                  @save="save(props.item)"
                                  @cancel="cancel"
                                  @open="open"
                                  @close="close"
                              >
                                {{ props.item.date }}
                                <template v-slot:input>
                                  <v-text-field
                                      type="date"
                                      v-model="props.item.date"
                                      label="Edit"
                                      single-line
                                      counter
                                  ></v-text-field>
                                </template>
                              </v-edit-dialog>
                            </template>
                            <template v-slot:item.action="{item}">
                              <div align="center">
                                <v-btn color="red" outlined @click="delRecript(item)">
                                  ลบ
                                </v-btn>
                              </div>
                            </template>
                          </v-data-table>
                        </v-list-item>
                        <v-list-item class="justify-center" v-if="ReCheckRecript.length > 0">
                          <v-data-table :headers="RecriptHeader" :items="ReCheckRecript">

                          </v-data-table>
                        </v-list-item>
                        <input type="file" class="form-control" id="pic3"
                               placeholder="" style="background-color:#f8e1cb;margin-top: 30px"
                               @change="FileSelectRecript" v-if="ChkImageRecript">
                        <v-divider></v-divider>
                        <div class="col-sm-10 col-sm-offset-1" align="center"
                             style="margin-top: 20px">
                          <div class="form-group">
                            <label>4) สำเนาคู่มือทะเบียนรถ</label>
                          </div>
                          <img v-if="ImageHomeType" :src="ImageHome"
                               class="img-responsive"
                               style="cursor: pointer"
                               @click="ShowData(ImageHome)"/>
                          <iframe v-else-if="pdfHomeType" :src="ImageHome"
                                  style="width:400px; height:300px;" frameborder="0"
                                  @click="ShowData(ImageHome)"></iframe>
                          <v-card v-else>
                            <v-alert
                                dense
                                outlined
                                type="error"
                            >
                              ไม่พบข้อมูลสำเนาคู่มือทะเบียนรถ
                            </v-alert>
                          </v-card>
                          <div v-if="ImageHomeType" align="center">
                            <button class="btn btn-info"
                                    style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                    @click="ShowData(ImageHome)">เปิดรูป
                            </button>
                            <button class="btn btn-info"
                                    style="color: #c7254e;margin-top: 10px;padding: 10px"
                                    @click="DelPic('4')">ลบไฟล์
                            </button>
                          </div>
                          <div v-else-if="pdfHomeType" align="center">
                            <button class="btn btn-info"
                                    style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                    @click="ShowData(ImageHome)">เปิด PDF
                            </button>
                            <button class="btn btn-info"
                                    style="color: #c7254e;margin-top: 10px;padding: 10px"
                                    @click="DelPic('4')">ลบไฟล์
                            </button>
                          </div>
                          <v-list-item>
                            <v-spacer></v-spacer>
                            <v-checkbox v-model="ChkImageHome"
                                        label="แก้ไขสำเนาคู่มือทะเบียนรถ" color="yellow"
                                        class="justify-center"></v-checkbox>
                            <v-spacer></v-spacer>
                          </v-list-item>
                          <input type="file" class="form-control" id="pic4"
                                 placeholder=""
                                 style="background-color:#f8e1cb;margin-top: 30px"
                                 @change="FileSelectHome" v-if="ChkImageHome">
                          <v-divider></v-divider>
                        </div>
                      </div>
                    </div>
                    <v-divider></v-divider>
                    <v-alert
                        dense
                        outlined
                        type="warning"
                    >
                      กรณีมีการแก้ไขข้อมูลสามารถอัพเดทข้อมูลใหม่ได้โดยกดปุ่มด้านล่าง
                    </v-alert>
                    <div>
                      <v-btn outlined @click="SubmitForm" color="green" :disabled="CheckSubmit">
                        อัพเดทข้อมูล
                      </v-btn>
                    </div>
                    <v-divider></v-divider>

                    <div class="row">
                      <div class="col-sm-12"><br>

                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:left;background-color:#fe1800;color:#fff">
                          &nbsp;&nbsp;อนุมัติการขอทำบัตร</h5>

                        <v-alert
                            dense
                            outlined
                            type="error"
                            v-if="CardObj.status_id == '3'"
                        >
                          ไม่อนุมัติทำบัตร : เหตุผล {{ ApproveDetail }}
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="success"
                            v-else-if="CardObj.status_id == '2'"
                        >
                          อนุมัติทำบัตร
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="success"
                            color="#78909C"
                            v-else-if="CardObj.status_id == '4'"
                        >
                          พิมพ์บัตร
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="success"
                            color="#00C853"
                            v-else-if="CardObj.status_id == '5'"
                        >
                          จ่ายบัตร
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="warning"
                            v-else
                            color="#1976D2"
                        >
                          ยื่นคำขอทำบัตร
                        </v-alert>

                        <div class="row">
                          <div class="col-md-12">
                            <v-radio-group v-model="status" row>
                              <v-radio label="ยื่นคำขอทำบัตร" value="0"></v-radio>
                              <v-radio label="แก้ไข" value="6"></v-radio>
                              <v-radio label="อนุมัติ" value="2"></v-radio>
                              <v-radio label="ไม่อนุมัติ" value="3"></v-radio>
                              <v-radio label="พิมพ์บัตร" value="4"></v-radio>
                              <v-radio label="จ่ายบัตร" value="5"></v-radio>
                            </v-radio-group>
                          </div>
                        </div>

                        <div align="center" style="margin-top: 25px" v-if="status == '3' || status == '6'">
                          <label style="margin-bottom: 15px">เหตุผล</label>
                          <div>
                                                        <textarea type="text" v-model="ApproveDetail"
                                                                  style="width: 600px;height: 100px;border: 2px silver solid"/>
                          </div>
                        </div>

                        <div align="center" style="margin-top: 25px">
                          <v-btn outlined color="primary" @click="ApproveData">บันทึก</v-btn>
                        </div>

                        <div align="left" style="margin-left: 30px">
                          <button class="btn btn-warning" @click="showDetailsFunc">
                            ย้อนกลับ
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card wizard-card" data-color="red" id="wizard" v-if="showPage === '4'">
                <div>

                  <div class="wizard-header">
                    <h3 class="wizard-title" style="color:#000; font-family:Prompt"><u>ข้อมูลรายละเอียดขอทำบัตรสำหรับผู้ประกอบการ,ร้านค้า</u>
                    </h3>
                    <p class="category">====================================</p>
                  </div>

                  <div align="left" style="margin-left: 30px">
                    <button class="btn btn-warning" @click="showDetailsFunc">
                      ย้อนกลับ
                    </button>
                  </div>

                  <div class="tab-content">
                    <div class="row">
                      <div class="col-sm-12"><br>

                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:left;background-color:#fe1800;color:#fff">
                          &nbsp;&nbsp;ตัวอย่างบัตร</h5>
                      </div>

                      <div class="col-sm-6"
                           style="margin-top: 15px;height: fit-content;width: 100%"
                           align="center">
                        <div class="form-group"
                             style="text-align:center;height: 435px;width: fit-content">
                          <img src="../assets/img/c3.jpg" width="278" height="440">
                          <div style="top: -328px;position: relative;left: -39px;width: 162px;font-weight: bold"
                               align="right">
                            <span>ผู้ประกอบการร้านค้า</span>
                          </div>
                          <div class="ShopShow"
                               style="top: -328px;position: relative;width: fit-content;font-size: 14px;font-weight: bold;float: left;"
                               align="left">
                            <span
                                style="display: block;height: 126px;width: 120px;text-align: right">{{
                                ShopShow
                              }}</span>
                          </div>
                          <!--<div style="top: -348px;position: relative;left: -8px;width: 100%;font-size: 22px;font-weight: bold"
                               align="left">
                              <span>{{ShopShow}}</span>
                          </div>-->
                          <img :src="ImagePerson" width="130" height="150"
                               style="position: relative;top: -345px;object-fit: contain;">
                          <div
                              style="top: -328px;position: relative;left: -8px;width: 100%;font-size: 22px;font-weight: bold"
                              align="right">
                            <span>{{ nameTh }} {{ surnameTh }}</span>
                          </div>

                          <div
                              style="top: -239px;position: relative;left: 23px;width: 162px;font-weight: bold;font-size: 17px;text-align:left"
                              align="right">
                            <span v-if="nameTh != ''">{{ DateExpire | DateToThaiManageCard }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" style="margin-top: 15px;width: 100%" align="center">
                        <div class="form-group" style="text-align:center">
                          <img src="../assets/img/c4.jpg" width="278" height="440">

                        </div>
                      </div>


                    </div>
                    <div class="row">

                      <div class="col-sm-12"><br>

                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:left;background-color:#fe1800; color:#fff">
                          &nbsp;&nbsp;1. ข้อมูลผู้ประกอบการ,ร้านค้า</h5>
                      </div>
                      <div class="col-sm-12" align="center">
                        <div class="row">
                          <div class="col-md-4">
                          </div>
                          <div class="col-md-4">
                            <div class="form-group" align="center">
                              <v-select label="ประเภทกิจการ" :items="optionsSelect"
                                        item-text="type_name" item-value="id"
                                        v-model="shop_type" outlined></v-select>
                            </div>
                          </div>
                          <div class="col-md-4">
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-12" align="center">
                        <div class="form-group" align="center">
                          <v-text-field label="ชื่อร้าน" outlined
                                        v-model="shop_name"></v-text-field>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <h5 class="info-text"
                          style="font-family:Prompt; text-align:left;background-color:#fe1800;color:#fff">
                        &nbsp;&nbsp;2. เจ้าของกิจการ</h5>
                    </div>
                    <div class="row">
                      <div class="col-sm-5 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="ชื่อ(ภาษาไทย)" outlined
                                        v-model="nameTh"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-text-field label="นามสกุล(ภาษาไทย)" outlined
                                        v-model="surnameTh"></v-text-field>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-text-field label="เลขที่บัตรประชาชน" outlined
                                        v-model="idcard"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-text-field type="date" label="วัน/เดือน/ปี เกิด" outlined
                                        v-model="brithDay"></v-text-field>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-select :items="genderOption" item-value="option"
                                    item-text="option" label="เพศ" outlined
                                    v-model="gender"></v-select>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <div class="form-group">
                          <v-text-field label="โทรศัพท์เคลื่อนที่" outlined
                                        v-model="phoneMoblie"></v-text-field>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-5 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="โทรศัพท์บ้าน" outlined
                                        v-model="phoneHome"></v-text-field>
                        </div>
                      </div>
                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-text-field label="อีเมลล์" outlined
                                        v-model="email"></v-text-field>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-10 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="ทีอยู่สามารถติดต่อได้" outlined
                                        v-model="address"></v-text-field>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-5 col-sm-offset-1" v-if="shop_type == '27'">
                        <div class="form-group">
                          <v-text-field label="เป็นผู้ปกครอง" outlined
                                        v-model="adult_name"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-5" v-if="shop_type == '27'">
                        <div class="form-group">
                          <v-select label="ความสัมพันธ์" :items="relationshipData"
                                    item-text="relationship" item-value="id"
                                    v-model="relationship" outlined></v-select>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-5 col-sm-offset-1">
                        <div class="form-group">
                          <v-text-field label="ทะเบียนรถ" outlined
                                        v-model="vehicleReg"></v-text-field>
                        </div>
                      </div>

                      <div class="col-sm-5">
                        <div class="form-group">
                          <v-autocomplete outlined label="จังหวัด" :items="ProviceData"
                                          item-value="id"
                                          item-text="name_in_thai"
                                          v-model="vehicleRegProvice"></v-autocomplete>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12"><br>

                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:left;background-color:#fe1800;color:#fff">
                          &nbsp;&nbsp;หลักฐานประกอบการทำบัตรร้านค้า</h5>
                      </div>

                      <div class="col-sm-10 col-sm-offset-1" align="center">
                        <div class="form-group">
                          <label>1) รูปถ่าย ขนาด 1 นิ้ว (หน้าตรง ไม่สวมหมวก
                            ไม่สวมแว่นดำ)</label>
                        </div>
                        <img v-if="ImagePersonType" :src="ImagePerson"
                             class="img-responsive"
                             style="cursor: pointer"
                             @click="ShowData(ImagePerson)"/>
                        <iframe v-else-if="pdfPersonType" :src="ImagePerson"
                                style="width:400px; height:300px;"
                                frameborder="0" @click="ShowData(ImagePerson)"></iframe>
                        <v-card v-else>
                          <v-alert
                              dense
                              outlined
                              type="error"
                          >
                            ไม่พบข้อมูลรูปถ่าย
                          </v-alert>
                        </v-card>
                        <div v-if="ImagePersonType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePerson)">เปิดรูป
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('1')">ลบไฟล์
                          </button>
                        </div>
                        <div v-else-if="pdfPersonType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePerson)">เปิด PDF
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('1')">ลบไฟล์
                          </button>
                        </div>
                        <v-list-item>
                          <v-spacer></v-spacer>
                          <v-checkbox v-model="ChkImagePerson" label="แก้ไขรูปภาพ"
                                      color="yellow" @change="EditImagePerson"
                                      class="justify-center"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-list-item>
                        <div class="col-sm-12" align="center" v-if="ChkImagePerson">
                          <p style="font-family:Prompt;color: black;font-weight: bold">
                            เลือกตำแหน่งรูปภาพ</p>
                          <div style="border: 2px solid;border-color: #327339;padding: 10px">
                            <div class="cropper-wrapper" style="width: 100%;">
                              <div :style="{backgroundImage: 'url(' + pic_Profile + ')'}"
                                   class="cropper-background"></div>
                              <Cropper
                                  :src="pic_Profile"
                                  :restrictions="pixelsRestriction"
                                  @change="onChangePic"
                              />
                            </div>
                            <button class="btn btn-warning" @click="rotate"
                                    style="margin-top: 15px">
                              ** หมุนรูปภาพ **
                            </button>
                          </div>

                        </div>
                        <input type="file" class="form-control" id="pic"
                               placeholder="" style="background-color:#f8e1cb;margin-top: 30px"
                               @change="onFileSelected" v-if="ChkImagePerson">
                      </div>


                      <div class="col-sm-10 col-sm-offset-1" align="center"
                           style="margin-top: 20px">
                        <div class="form-group">
                          <label>2) สำเนาบัตรประจำตัวประชาชน</label>
                        </div>
                        <img v-if="ImagePersonCopyType" :src="ImagePersonCopy"
                             class="img-responsive"
                             style="cursor: pointer"
                             @click="ShowData(ImagePersonCopy)"/>
                        <iframe v-else-if="pdfPersonCopyType" :src="ImagePersonCopy"
                                style="width:400px; height:300px;" frameborder="0"
                                @click="ShowData(ImagePersonCopy)"></iframe>
                        <v-card v-else>
                          <v-alert
                              dense
                              outlined
                              type="error"
                          >
                            ไม่พบข้อมูลสำเนาบัตรประจำตัวประชาชน
                          </v-alert>
                        </v-card>
                        <div v-if="ImagePersonCopyType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePersonCopy)">เปิดรูป
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('2')">ลบไฟล์
                          </button>
                        </div>
                        <div v-else-if="pdfPersonCopyType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImagePersonCopy)">เปิด PDF
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('2')">ลบไฟล์
                          </button>
                        </div>
                        <v-list-item>
                          <v-spacer></v-spacer>
                          <v-checkbox v-model="ChkImagePersonCopy"
                                      label="แก้ไขสำเนาบัตรประจำตัวประชาชน" color="yellow"
                                      class="justify-center"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-list-item>
                        <input type="file" class="form-control" id="pic2"
                               placeholder="" style="background-color:#f8e1cb;margin-top: 30px"
                               @change="FileSelectPersonal" v-if="ChkImagePersonCopy">
                        <v-divider></v-divider>
                      </div>


                      <div class="col-sm-10 col-sm-offset-1" align="center"
                           style="margin-top: 20px">
                        <div class="form-group">
                          <label>3) ใบเสร็จรับเงิน งานคลัง คณะแพทยศาสตร์</label>
                        </div>
                        <img v-if="ImageRecriptType" :src="ImageRecript"
                             class="img-responsive"
                             style="cursor: pointer"
                             @click="ShowData(ImageRecript)"/>
                        <iframe v-else-if="pdfRecriptType" :src="ImageRecript"
                                style="width:400px; height:300px;" frameborder="0"
                                @click="ShowData(ImageRecript)"></iframe>
                        <v-card v-else>
                          <v-alert
                              dense
                              outlined
                              type="error"
                          >
                            ไม่พบข้อมูลใบเสร็จรับเงิน
                          </v-alert>
                        </v-card>
                        <div v-if="ImageRecriptType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImageRecript)">เปิดรูป
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('3')">ลบไฟล์
                          </button>
                        </div>
                        <div v-else-if="pdfRecriptType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImageRecript)">เปิด PDF
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('3')">ลบไฟล์
                          </button>
                        </div>
                        <v-list-item>
                          <v-spacer></v-spacer>
                          <v-checkbox v-model="ChkImageRecript" label="แก้ไขใบเสร็จรับเงิน"
                                      color="yellow" class="justify-center"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-list-item>
                        <input type="file" class="form-control" id="pic3"
                               placeholder="" style="background-color:#f8e1cb;margin-top: 30px"
                               @change="FileSelectRecript" v-if="ChkImageRecript">
                        <v-divider></v-divider>
                      </div>
                      <v-list-item class="d-flex" v-if="RecriptData.length == 0">
                        <v-text-field type="number" outlined label="เลขที่ใบเสร็จ"
                                      class="ma-2" v-model="recript1"></v-text-field>
                        <span style="font-weight: bold;transform: scale(2)" class="mb-6">-</span>
                        <v-text-field type="number" outlined label="เลขที่ใบเสร็จ"
                                      class="ma-2" v-model="recript2"></v-text-field>
                      </v-list-item>
                      <v-list-item>
                        <v-text-field type="date" outlined label="วันที่ออกใบเสร็จ"
                                      class="ma-2" v-model="date" v-if="RecriptData.length == 0"></v-text-field>
                      </v-list-item>
                      <v-list-item class="justify-center" v-if="RecriptData.length == 0">
                        <v-textarea outlined label="หมายเหตุ (ถ้ามี)" v-model="remark"></v-textarea>
                      </v-list-item>
                      <v-list-item class="justify-center" v-if="RecriptData.length == 0">
                        <v-btn outlined color="pink" class="darken-4 ma-4" @click="ReCheckDupeRecript">ตรวจสอบ</v-btn>
                        <v-btn outlined color="primary" class="darken-4 ma-4" @click="saveRecript">บันทึก</v-btn>
                      </v-list-item>
                      <v-list-item v-if="CheckRecript">
                        <v-alert
                            style="width: 100%"
                            class="d-block"
                            dense
                            outlined
                            type="success"
                            v-if="ReCheckRecript.length == 0"
                        >
                          ไม่พบข้อมูลใบเสร็จซํ้า
                        </v-alert>
                        <v-alert
                            style="width: 100%"
                            class="d-block"
                            dense
                            outlined
                            type="error"
                            v-else
                        >
                          พบรายการใบเสร็จซํ้าโปรดตรวจสอบ
                        </v-alert>
                      </v-list-item>
                      <v-list-item class="justify-center" v-if="RecriptData.length > 0">
                        <v-data-table :headers="RecriptHeader" :items="RecriptData">
                          <template v-slot:item.recript_no="props">
                            <v-edit-dialog
                                :return-value.sync="props.item.recript_no"
                                @save="save(props.item)"
                                @cancel="cancel"
                                @open="open"
                                @close="close"
                            >
                              {{ props.item.recript_no }}
                              <template v-slot:input>
                                <v-text-field
                                    v-model="props.item.recript_no"
                                    label="Edit"
                                    single-line
                                    counter
                                ></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </template>
                          <template v-slot:item.date="props">
                            <v-edit-dialog
                                :return-value.sync="props.item.date"
                                @save="save(props.item)"
                                @cancel="cancel"
                                @open="open"
                                @close="close"
                            >
                              {{ props.item.date }}
                              <template v-slot:input>
                                <v-text-field
                                    type="date"
                                    v-model="props.item.date"
                                    label="Edit"
                                    single-line
                                    counter
                                ></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </template>
                          <template v-slot:item.action="{item}">
                            <div align="center">
                              <v-btn color="red" outlined @click="delRecript(item)">
                                ลบ
                              </v-btn>
                            </div>
                          </template>
                        </v-data-table>
                      </v-list-item>
                      <v-list-item class="justify-center" v-if="ReCheckRecript.length > 0">
                        <v-data-table :headers="RecriptHeader" :items="ReCheckRecript">

                        </v-data-table>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="col-sm-10 col-sm-offset-1" align="center"
                           style="margin-top: 20px">
                        <div class="form-group">
                          <label>4) สำเนาคู่มือทะเบียนรถ</label>
                        </div>
                        <img v-if="ImageHomeType" :src="ImageHome"
                             class="img-responsive"
                             style="cursor: pointer"
                             @click="ShowData(ImageHome)"/>
                        <iframe v-else-if="pdfHomeType" :src="ImageHome"
                                style="width:400px; height:300px;" frameborder="0"
                                @click="ShowData(ImageHome)"></iframe>
                        <v-card v-else>
                          <v-alert
                              dense
                              outlined
                              type="error"
                          >
                            ไม่พบข้อมูลสำเนาคู่มือทะเบียนรถ
                          </v-alert>
                        </v-card>
                        <div v-if="ImageHomeType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImageHome)">เปิดรูป
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('4')">ลบไฟล์
                          </button>
                        </div>
                        <div v-else-if="pdfHomeType" align="center">
                          <button class="btn btn-info"
                                  style="color: rgba(91,104,185,0.99);margin-top: 10px"
                                  @click="ShowData(ImageHome)">เปิด PDF
                          </button>
                          <button class="btn btn-info"
                                  style="color: #c7254e;margin-top: 10px;padding: 10px"
                                  @click="DelPic('4')">ลบไฟล์
                          </button>
                        </div>
                        <v-list-item>
                          <v-spacer></v-spacer>
                          <v-checkbox v-model="ChkImageHome" label="แก้ไขสำเนาคู่มือทะเบียนรถ"
                                      color="yellow" class="justify-center"></v-checkbox>
                          <v-spacer></v-spacer>
                        </v-list-item>
                        <input type="file" class="form-control" id="pic4"
                               placeholder="" style="background-color:#f8e1cb;margin-top: 30px"
                               @change="FileSelectHome" v-if="ChkImageHome">
                        <v-divider></v-divider>
                      </div>
                    </div>
                    <v-divider></v-divider>
                    <v-alert
                        dense
                        outlined
                        type="warning"
                    >
                      กรณีมีการแก้ไขข้อมูลสามารถอัพเดทข้อมูลใหม่ได้โดยกดปุ่มด้านล่าง
                    </v-alert>
                    <div>
                      <v-btn outlined @click="SubmitForm" color="green" :disabled="CheckSubmit">
                        อัพเดทข้อมูล
                      </v-btn>
                    </div>
                    <v-divider></v-divider>

                    <div class="row">
                      <div class="col-sm-12"><br>

                        <h5 class="info-text"
                            style="font-family:Prompt; text-align:left;background-color:#fe1800;color:#fff">
                          &nbsp;&nbsp;อนุมัติการขอทำบัตร</h5>

                        <v-alert
                            dense
                            outlined
                            type="error"
                            v-if="CardObj.status_id == '3'"
                        >
                          ไม่อนุมัติทำบัตร : เหตุผล {{ ApproveDetail }}
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="success"
                            v-else-if="CardObj.status_id == '2'"
                        >
                          อนุมัติทำบัตร
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="success"
                            color="#78909C"
                            v-else-if="CardObj.status_id == '4'"
                        >
                          พิมพ์บัตร
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="success"
                            color="#00C853"
                            v-else-if="CardObj.status_id == '5'"
                        >
                          จ่ายบัตร
                        </v-alert>
                        <v-alert
                            dense
                            outlined
                            type="warning"
                            v-else
                            color="#1976D2"
                        >
                          ยื่นคำขอทำบัตร
                        </v-alert>

                        <div class="row">
                          <div class="col-md-12">
                            <v-radio-group v-model="status" row>
                              <v-radio label="ยื่นคำขอทำบัตร" value="0"></v-radio>
                              <v-radio label="แก้ไข" value="6"></v-radio>
                              <v-radio label="อนุมัติ" value="2"></v-radio>
                              <v-radio label="ไม่อนุมัติ" value="3"></v-radio>
                              <v-radio label="พิมพ์บัตร" value="4"></v-radio>
                              <v-radio label="จ่ายบัตร" value="5"></v-radio>
                            </v-radio-group>
                          </div>
                        </div>

                        <div align="center" style="margin-top: 25px" v-if="status == '3' || status == '6'">
                          <label style="margin-bottom: 15px">เหตุผล</label>
                          <div>
                                                        <textarea type="text" v-model="ApproveDetail"
                                                                  style="width: 600px;height: 100px;border: 2px silver solid"/>
                          </div>
                        </div>

                        <div align="center" style="margin-top: 25px">
                          <button class="btn btn-success" @click="ApproveData">บันทึก</button>
                        </div>

                        <div align="left" style="margin-left: 30px">
                          <button class="btn btn-warning" @click="showDetailsFunc">
                            ย้อนกลับ
                          </button>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div> <!-- wizard container -->
          </transition>

          <h5 align="center" style="color:#000; font-family:prompt;">
            หน่วยรักษาความปลอดภัย ชั้น 2 อาคารบริหาร คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์ ติดต่อ
            074-45-1122
          </h5>
        </div>

        <div class="col-sm-8 col-sm-offset-2" style="background-color:#8c8c8c" v-if="manageMenu == '1'">
          <h3 align="center" style="color:#000; font-family:Prompt">จัดการข้อมูลประเภทร้านค้า&nbsp;&nbsp;<a
              href="index.html" style="color:#000"><i class="ti-home"></i></a>
          </h3>
          <transition name="slide-fade">
            <div class="wizard-container" v-if="!ShowDetails">

              <div class="card wizard-card" data-color="orange" id="wizardProfile">
                <div>
                  <!--        You can switch " data-color="orange" "  with one of the next bright colors: "blue", "green", "orange", "red", "azure"          -->

                  <div class="wizard-header text-center">
                    <div align="right" style="">{{ nameAdmin }} {{ surnameAdmin }} {{ depart }}
                    </div>
                    <div class="tab-content" style="margin-top:-20px;">
                      <div class="row">
                        <div class="col-sm-12 col-sm-offset-0">
                          <h4 style="color:#000; font-family:Prompt"><u>ประเภทร้านค้า</u>
                          </h4>
                        </div>
                        <div class="col-sm-12 col-sm-offset-0">
                          <input type="text" class="form-control"
                                 style="background-color: #fcffd2;text-align: center"
                                 v-model="typeShop"/>
                          <button class="btn btn-info" style="margin-top: 15px"
                                  @click="insertData">เพิ่มข้อมูล
                          </button>
                        </div>

                        <div class="col-sm-12 col-sm-offset-0" style="margin-top: 30px">
                          <table class="table" style="color:#fff; font-family:Prompt">
                            <tr style="color:#fff; font-family:Prompt; font-size:18px;; background-color:#8cc63e"
                                align="left">
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">#
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">ประเภท
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">สถานะ
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">
                              </td>
                            </tr>

                            <tr v-for="(shopItem, index) in ShopMs"
                                v-bind:key="shopItem.id">
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ index + 1 }}
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ shopItem.type_name }}
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">
                                                                <span v-if="shopItem.is_used == 1"
                                                                      style="color: #1b6d85">ใช้งาน</span>
                                <span v-if="shopItem.is_used == 1"
                                      style="color: #761c19;margin-left: 10px">
                                                                        <button class="btn btn-info"
                                                                                style="color: #ff4d51"
                                                                                @click="ChangeStatus(0, shopItem)">
                                                                        ยกเลิก
                                                                    </button>
                                                                    </span>
                                <span v-if="shopItem.is_used == 0"
                                      style="color: #1b6d85">
                                                                        <button class="btn btn-info"
                                                                                style="color: #ff4d51"
                                                                                @click="ChangeStatus(1, shopItem)">
                                                                        ใช้งาน
                                                                    </button>
                                                                    </span>
                                <span v-if="shopItem.is_used == 0"
                                      style="color: #761c19;margin-left: 10px">
                                                                        ยกเลิก
                                                                    </span>
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                <button class="btn btn-info" style="color: #ff4d51"
                                        @click="deleteData(shopItem)">
                                  ลบ
                                </button>
                              </td>
                            </tr>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

        </div>

        <div class="col-sm-8 col-sm-offset-2" style="background-color:#8c8c8c" v-if="manageMenu == '2'">
          <h3 align="center" style="color:#000; font-family:Prompt">จัดการข้อมูลความสัมพันธ์&nbsp;&nbsp;<a
              href="index.html" style="color:#000"><i class="ti-home"></i></a>
          </h3>
          <transition name="slide-fade">
            <div class="wizard-container" v-if="!ShowDetails">

              <div class="card wizard-card" data-color="orange" id="wizardProfile">
                <div>
                  <!--        You can switch " data-color="orange" "  with one of the next bright colors: "blue", "green", "orange", "red", "azure"          -->

                  <div class="wizard-header text-center">
                    <div align="right" style="">{{ nameAdmin }} {{ surnameAdmin }} {{ depart }}
                    </div>
                    <div class="tab-content" style="margin-top:-20px;">
                      <div class="row">
                        <div class="col-sm-12 col-sm-offset-0">
                          <h4 style="color:#000; font-family:Prompt"><u>ประเภทความสัมพันธ์</u>
                          </h4>
                        </div>
                        <div class="col-sm-12 col-sm-offset-0">
                          <input type="text" class="form-control"
                                 style="background-color: #fcffd2;text-align: center"
                                 v-model="typeRelation"/>
                          <button class="btn btn-info" style="margin-top: 15px"
                                  @click="insertDataRelation">เพิ่มข้อมูล
                          </button>
                        </div>

                        <div class="col-sm-12 col-sm-offset-0" style="margin-top: 30px">
                          <table class="table" style="color:#fff; font-family:Prompt">
                            <tr style="color:#fff; font-family:Prompt; font-size:18px;; background-color:#8cc63e"
                                align="left">
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">#
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">ประเภท
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">สถานะ
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">
                              </td>
                            </tr>

                            <tr v-for="(rela_Item, index) in relationship_ms"
                                v-bind:key="rela_Item.id">
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ index + 1 }}
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ rela_Item.relationship }}
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">
                                                                <span v-if="rela_Item.is_used == 1"
                                                                      style="color: #1b6d85">ใช้งาน</span>
                                <span v-if="rela_Item.is_used == 1"
                                      style="color: #761c19;margin-left: 10px">
                                                                        <button class="btn btn-info"
                                                                                style="color: #ff4d51"
                                                                                @click="ChangeStatusRelation(0, rela_Item)">
                                                                        ยกเลิก
                                                                    </button>
                                                                    </span>
                                <span v-if="rela_Item.is_used == 0"
                                      style="color: #1b6d85">
                                                                        <button class="btn btn-info"
                                                                                style="color: #ff4d51"
                                                                                @click="ChangeStatusRelation(1, rela_Item)">
                                                                        ใช้งาน
                                                                    </button>
                                                                    </span>
                                <span v-if="rela_Item.is_used == 0"
                                      style="color: #761c19;margin-left: 10px">
                                                                        ยกเลิก
                                                                    </span>
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                <button class="btn btn-info" style="color: #ff4d51"
                                        @click="deleteDataRelation(rela_Item)">
                                  ลบ
                                </button>
                              </td>
                            </tr>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

        </div>

        <div class="col-sm-8 col-sm-offset-2" style="background-color:#8c8c8c" v-if="manageMenu == '3'">
          <h3 align="center" style="color:#000; font-family:Prompt">เพิ่มสิทธิ์การเข้าทำบัตรญาติ&nbsp;&nbsp;<a
              href="index.html" style="color:#000"><i class="ti-home"></i></a>
          </h3>
          <transition name="slide-fade">
            <div class="wizard-container" v-if="!ShowDetails">

              <div class="card wizard-card" data-color="orange" id="wizardProfile">
                <div>
                  <!--        You can switch " data-color="orange" "  with one of the next bright colors: "blue", "green", "orange", "red", "azure"          -->

                  <div class="wizard-header text-center">
                    <div align="right" style="">{{ nameAdmin }} {{ surnameAdmin }} {{ depart }}
                    </div>
                    <div class="tab-content" style="margin-top:-20px;">
                      <div class="row">
                        <div class="col-sm-12 col-sm-offset-0">
                          <h4 style="color:#000; font-family:Prompt"><u>เพิ่มบุคลากรเข้าทำบัตรญาติ</u>
                          </h4>
                        </div>
                        <div class="col-sm-12 col-sm-offset-0">
                          <v-list-item>
                            <v-autocomplete outlined v-model="uid" label="เลือกบุคลากร"
                                            :items="staffData" item-value="perid"
                                            item-text="searchDetail">
                            </v-autocomplete>
                          </v-list-item>
                          <button class="btn btn-info" style="margin-top: 15px"
                                  @click="insertPersonPermiss">เพิ่มข้อมูล
                          </button>
                        </div>

                        <div class="col-sm-12 col-sm-offset-0" style="margin-top: 30px">
                          <table class="table" style="color:#fff; font-family:Prompt">
                            <tr style="color:#fff; font-family:Prompt; font-size:18px;; background-color:#8cc63e"
                                align="left">
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">#
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">รหัสบุคลากร
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">ชื่อ-สกุล
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">สังกัด
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">ตำแหน่ง
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">
                              </td>
                            </tr>

                            <tr v-for="(permiss_Item, index) in permiss_relative"
                                v-bind:key="permiss_Item.id">
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ index + 1 }}
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ permiss_Item.perid }}
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ permiss_Item.full_Name }}
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ permiss_Item.dep_name }}
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                {{ permiss_Item.pos_name }}
                              </td>
                              <td style="color:#fff; font-family:Prompt; font-size:18px;"
                                  align="center">
                                                                <span v-if="permiss_Item.permiss_active == 1"
                                                                      style="color: #1b6d85">ใช้งาน</span>
                                <span v-if="permiss_Item.permiss_active == 1"
                                      style="color: #761c19;margin-left: 10px">
                                                                        <button class="btn btn-info"
                                                                                style="color: #ff4d51"
                                                                                @click="ChangeStatusPermiss(0, permiss_Item)">
                                                                        ยกเลิก
                                                                    </button>
                                                                    </span>
                                <span v-if="permiss_Item.permiss_active == 0"
                                      style="color: #1b6d85">
                                                                        <button class="btn btn-info"
                                                                                style="color: #ff4d51"
                                                                                @click="ChangeStatusPermiss(1, permiss_Item)">
                                                                        ใช้งาน
                                                                    </button>
                                                                    </span>
                                <span v-if="permiss_Item.permiss_active == 0"
                                      style="color: #761c19;margin-left: 10px">
                                                                        ยกเลิก
                                                                    </span>
                              </td>
                              <td style="color:#000; font-family:Prompt; font-size:18px;"
                                  align="center">
                                <button class="btn btn-info" style="color: #ff4d51"
                                        @click="deleteDataPermiss(permiss_Item)">
                                  ลบ
                                </button>
                              </td>
                            </tr>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

        </div>

        <div class="col-sm-8 col-sm-offset-2" align="left" style="margin-top: 25px">
          <button class="btn btn-danger" @click="blackMenu" style="color: red"> กลับสู่หน้า Home</button>
        </div>

      </div><!-- end row -->
    </div>
    <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
            v-bind="attrs"
            text
            @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <template>
      <v-dialog
          v-model="dialogShowCardHis"
          scrollable
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card v-if="cardHistoryObj != null">
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="dialogShowCardHis = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="cardHistoryObj.Type == 'ญาติ'">ประวัติการทำรายการ คุณ : {{namePerson}} : ({{cardHistoryObj.perid}})</v-toolbar-title>
            <v-toolbar-title v-else>ประวัติการทำรายการ รหัสบัตรประชาชน : {{namePerson}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="dialogShowCardHis = false"
              >
                Close
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text  style="height: 100%">
            <v-list>
              <v-list-item>
                <v-row class="d-flex justify-center">
                  <v-col
                      cols="12"
                      md="12">
                    <v-data-table
                        :headers="CardHistoryHeader"
                        :items="CardHistoryDetail"
                    >
                      <template v-slot:item.url_display="{ item }">
                        <img :src="ConnectionName + '/rest/files/' + item.url_display"
                             width="130"
                             height="150">
                      </template>
                      <template v-slot:item.Type="{item}">
                        <td style="color:#000; font-family:Prompt; font-size:12px;"
                            align="left">{{ item.Type }}
                        </td>
                      </template>
                      <template v-slot:item.FullName="{ item }">
                        <td style="color:#000; font-family:Prompt; font-size:12px;"
                            align="left">
                          <div v-html="item.FullName"></div>
                        </td>
                      </template>
                      <template v-slot:item.CardRequest="{ item }">
                        <v-chip color="#00bbff"
                                v-if="item.request_wish_id == '1'">
                          {{ item.CardRequest }}
                        </v-chip>
                        <v-chip color="#985f0d"
                                v-if="item.request_wish_id == '2'">
                          {{ item.CardRequest }}
                        </v-chip>
                        <v-chip color="#EA80FC"
                                v-if="item.request_wish_id == '4'">
                          {{ item.CardRequest }}
                        </v-chip>
                      </template>
                      <template v-slot:item.LicensePlate="{ item }">
                                                            <span v-if="item.license_plate != ''"
                                                                  style="color:#000; font-family:Prompt; font-size:12px;"
                                                                  align="left">{{ item.LicensePlate }}
                                                            </span>
                      </template>
                      <template v-slot:item.DateShow="{ item }">
                        <td style="color:#000; font-family:Prompt; font-size:12px;"
                            align="left">{{ item.DateShow }}
                        </td>
                      </template>
                      <template v-slot:item.expire_date="{ item }">
                        <td style="color:#000; font-family:Prompt; font-size:12px;"
                            align="left">{{ item.expire_date | DateToThaiManageCard }}
                        </td>
                      </template>
                      <template v-slot:item.status_name="{ item }">
                        <td style="color:blue; font-family:Prompt; font-size:12px;"
                            align="left"
                            v-if="item.status_id == '1' || item.status_id == '0'">
                          {{ item.status_name }}
                        </td>
                        <td style="color:#3c763d; font-family:Prompt; font-size:12px;"
                            align="left" v-if="item.status_id == '2'">
                          {{ item.status_name }}
                        </td>
                        <td style="color:rgba(185,11,19,0.99); font-family:Prompt; font-size:12px;"
                            align="left" v-if="item.status_id == '3'">
                          {{ item.status_name }}
                        </td>
                        <td style="color:#5e5e5e; font-family:Prompt; font-size:12px;"
                            align="left" v-if="item.status_id == '4'">
                          {{ item.status_name }}
                        </td>
                        <td style="color:rgba(148,24,185,0.99); font-family:Prompt; font-size:12px;"
                            align="left" v-if="item.status_id == '5'">
                          {{ item.status_name }}
                        </td>
                        <td style="color:#afb42b; font-family:Prompt; font-size:12px;"
                            align="left" v-if="item.status_id == '6'">
                          {{ item.status_name }}
                        </td>
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-list-item class="justify-center">
                          <v-btn outlined color="green"
                                 @click="showDetailsFunc(item)">รายละเอียด
                          </v-btn>
                        </v-list-item>
                        <v-list-item class="justify-center">
                          <v-btn outlined color="red"
                                 @click="DeleteCardItem(item)">ลบ
                          </v-btn>
                        </v-list-item>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card-text>

        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
          v-model="dialogCondition"
          scrollable
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="dialogCondition = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>กำหนดเงื่อนไขการทำบัตร</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="dialogCondition = false"
              >
                Close
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text  style="height: 100%">
            <v-list>
              <v-list-item>
                <v-row class="d-flex justify-center">
                  <v-col
                    cols="12"
                    md="8">
                    <v-list-item>
                      <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="4">
                          <v-autocomplete
                              v-model="condi_perid"
                              outlined
                              label="ค้นหาบุคลากร"
                              :items="staffData"
                              item-text="searchDetail"
                              item-value="perid"
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                            cols="12"
                            md="4">
                          <v-text-field outlined label="จำนวนบัตรที่ทำได้" v-model="condi_count"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row class="d-flex justify-center">
                        <v-col
                            cols="12"
                            md="6">
                          <v-textarea outlined label="เหตุผล" v-model="condi_remark">
                          </v-textarea>
                          </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-btn color="primary" @click="insertCondiCardData">บันทึก</v-btn>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row class="d-flex justify-center">
                  <v-col
                      cols="12"
                      md="8">
                    <v-data-table
                        :headers="ConditionHeader"
                        :items="conditionData"
                    >
                      <template v-slot:item.action="{item}">
                        <v-btn text color="pink" @click="editConditionData(item)">แก้ไข</v-btn>
                        <v-btn text color="red" @click="deleteConditionData(item)">ลบ</v-btn>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog
        v-model="dialogEditCondition"
        scrollable
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card v-if="CondiDataObj != null">
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="dialogEditCondition = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>แก้ไขข้อมูลเงื่อนไขการทำบัตร</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="dialogEditCondition = false"
              >
                Close
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-catd-text style="height: 100%">
            <v-list>
                <v-list-item>
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="4">
                      <v-autocomplete
                          v-model="edit_condi_perid"
                          outlined
                          label="ค้นหาบุคลากร"
                          :items="staffData"
                          item-text="searchDetail"
                          item-value="perid"
                          readonly
                      ></v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4">
                      <v-text-field outlined label="จำนวนบัตรที่ทำได้" v-model="edit_condi_count"></v-text-field>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row class="d-flex justify-center">
                    <v-col
                        cols="12"
                        md="6">
                      <v-textarea outlined label="เหตุผล" v-model="edit_condi_remark">
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-list-item>
              <v-list-item class="d-flex justify-center">
                <v-btn outlined color="pink" @click="editConditionDataExec">แก้ไข</v-btn>
              </v-list-item>
            </v-list>
          </v-catd-text>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import Vue from 'vue'
import ConstData from '../Const/Const'
import {Cropper} from "vue-advanced-cropper";
import queryString from "query-string";

export default {
  name: "ManageCardPP3S",
  components: {
    Cropper
  },
  data: function () {
    return {
      CondiDataObj: null,
      dialogCondition: false,
      dialogEditCondition: false,
      edit_condi_perid: null,
      edit_condi_count: '3',
      edit_condi_remark: '',
      condi_perid: null,
      condi_count: '3',
      condi_remark: '',
      conditionData: [],
      ConditionHeader: [
        {text: 'รหัสบุคลากร', value: 'perid'},
        {text: 'จำนวนบัตรที่ทำได้', value: 'count'},
        {text: 'หมายเหตุ', value: 'remark'},
        {text: '', value: 'action'},
      ],
      CardHistoryHeader: [
        {text: 'รูปภาพ', value: 'url_display'},
        {text: 'สถานะ', value: 'wish_name'},
        {text: 'ชื่อ สกุล', value: 'FullName'},
        {text: 'บัตร', value: 'CardRequest'},
        {text: 'ทะเบียนรถ', value: 'LicensePlate'},
        {text: 'วันที่ยืนขอทำบัตร', value: 'DateShow'},
        {text: 'วันที่หมดอายุธ', value: 'expire_date'},
        {text: 'หมายเหตุ', value: 'comment'},
        {text: 'สถานะดำเนินการ', value: 'status_name'},
        {text: '', value: 'action'}
      ],
      CardHistoryDetail: [],
      dialogShowCardHis: false,
      cardHistoryObj: null,
      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: v => v.length <= 25 || 'Input too long!',
      pagination: {},
      date: '',
      RecriptData: [],
      CheckRecript: false,
      ReCheckRecript: [],
      recript1: '',
      recript2: '',
      remark: '',
      rowsBackup2: [],
      permiss_relative: [],
      uid: '',
      CountTypeSec0: [],
      CountTypeSec2: [],
      CountTypeSec3: [],
      CountTypeSec4: [],
      CountTypeSec5: [],
      CountTypeSec6: [],
      CountType2: 0,
      CountType4: 0,
      CountTypeAll: 0,
      rdoCardType: '0',
      rdoCardType2: '0',
      optionsSelect: [],
      relationshipData: [],
      staffData: [],
      CheckSubmit: false,
      status: '',
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      imageCrop: null,
      ChkImageHome: false,
      ChkImageRecript: false,
      ChkImagePersonCopy: false,
      ChkImagePerson: false,
      pic_Profile: require('@/assets/img/NonPic.png'),
      contactData: [],
      attachment_data: [],
      ProviceData: [],
      genderOption: [
        {option: 'ชาย'},
        {option: 'หญิง'}
      ],
      scrollPosition: 0,
      ConnectionName: ConstData.ConnectionHost,
      adult_name: '',
      relationship: '',
      ChooseRelationship: '',
      backGround: {
        'background-color': '#8c8c8c'
      },
      search: '',
      singleExpand: false,
      dormData: [],
      RecriptHeader: [
        {text: 'เลขที่ใบเสร็จ', value: 'recript_no'},
        {text: 'วันที่ออกใบเสร็จ', value: 'date'},
        {text: 'หมายเหตุ', value: 'remark'},
        {text: '', value: 'action'}
      ],
      dormHeader: [
        {text: 'หอพัก', value: 'dorm_name'},
        {text: 'ห้องพัก', value: 'room_name'},
        {text: 'วันที่เข้าอยู่', value: 'stay_in_date'},
        {text: 'สถานะ', value: 'active'},
      ],
      columns: [
        {text: 'รูปภาพ', value: 'url_display'},
        {text: 'ประเภทบัตร', value: 'Type'},
        {text: 'สถานะ', value: 'wish_name'},
        {text: 'ชื่อ สกุล', value: 'FullName'},
        {text: 'บัตร', value: 'CardRequest'},
        {text: 'ทะเบียนรถ', value: 'LicensePlate'},
        {text: 'วันที่ยืนขอทำบัตร', value: 'DateShow'},
        {text: 'สถานะดำเนินการ', value: 'status_name'},
        {text: '', value: 'action'}
      ],
      rows: [],
      rowsBackup: [],
      vehicleReg: '',
      vehicleRegProvice: '',
      ShopShow: '',
      typeShop: '',
      typeRelation: '',
      ShopMs: [],
      relationship_ms: [],
      manageMenu: '0',
      CardObj: null,
      ApproveDetail: '',
      Approve: true,
      shop_type: '',
      shop_type_id: '',
      shop_name: '',
      showPage: '',
      CardDataPerson: [],
      ShowDetails: false,
      DateExpire: '',
      perid: '',
      peridAdmin: '',
      idcard: '',
      namePerson: '',
      nameAdmin: '',
      surnameAdmin: '',
      nameTh: '',
      nameEn: '',
      surnameTh: '',
      surnameEn: '',
      hn: '',
      brithDay: '',
      gender: '',
      depart: '',
      phoneDepart: '',
      phoneMoblie: '',
      phoneHome: '',
      position: '',
      email: '',
      address: '',
      dorm: '',
      dorm2: '',
      ImagePerson: '',
      ImageRecript: '',
      ImagePersonCopy: '',
      ImageHome: '',
      pdfPersonCopy: '',
      ImagePersonType: '',
      pdfPersonType: '',
      ImageRecriptType: '',
      pdfRecriptType: '',
      ImagePersonCopyType: '',
      pdfPersonCopyType: '',
      ImageHomeType: '',
      pdfHomeType: '',
      dataFormSubmit: {
        request: {
          request_types_id: "2",
          request_wish_id: "1",
          quantity: "1",
          card_status: "1",
          expire_date: "",
        },
        items: [
          {
            person: {
              person_types_id: "4",
              perid: "",
              citizenId: "",
              firstName: "",
              lastName: "",
              birthdate: "",
              sex: "",
              license_plate: "",
              provinces_id: ""
            },
            contact: [
              {
                contact_types_id: "1",
                value: ""
              },
              {
                contact_types_id: "2",
                value: ""
              },
              {
                contact_types_id: "3",
                value: ""
              },
              {
                contact_types_id: "4",
                value: ""
              },
              {
                contact_types_id: "5",
                value: ""
              },
              {
                contact_types_id: "6",
                value: ""
              }
            ],
            dorm: [
              {
                dorm_types_id: "1",
                value: "-"
              },
              {
                dorm_types_id: "2",
                value: "-"
              }
            ],
            vehicle: [],
            attachment: [
              {
                attachment_types_id: "1",
                url: ""
              },
              {
                attachment_types_id: "2",
                url: ""
              },
              {
                attachment_types_id: "3",
                url: ""
              },
              {
                attachment_types_id: "4",
                url: ""
              },
              {
                attachment_types_id: "5",
                url: ""
              }
            ],
            shop: [
              {
                shop_type_id: "",
                shop_name: ""
              }
            ],
            adult: [
              {
                adult_name: "",
                relationship_id: ""
              }
            ]
          }
        ]
      }
    }
  },
  methods: {
    CheckPermissMenu() {
      if (this.perid == '46792' || this.perid == '43654') return true
      return false
    },
    getStaffData() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/staff/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.staffData.push({
                ...item,
                searchDetail: 'รหัสบุคลากร : ' + item.perid + ' - ' + item.full_Name + ' (' + item.dep_name + ')'
              })
            })
          } else {
            this.staffData.push({
              ...res.data,
              searchDetail: 'รหัสบุคลากร : ' + res.data.perid + ' - ' + res.data.full_Name + ' (' + res.data.dep_name + ')'
            })
          }
        } else {
          this.staffData = []
        }
      })
    },
    getConditionData() {
      this.conditionData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/condition/active/1/?limit=9999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.conditionData = res.data
          } else {
            this.conditionData.push(res.data)
          }
        } else {
          this.conditionData = []
        }
      })
    },
    editConditionDataExec() {
      if (this.edit_condi_count == '' || parseInt(this.edit_condi_count) <= 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด โปรดตรวจสอบจำนวนบัตรที่ทำได้ จะต้องไม่เป็นค่าว่าง และ มีค่ามากกว่า 0'
        })
      } else {
        const headerAxios = {
          headers: {
            'Content-Type': 'application/json',
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/condition/id/' + this.CondiDataObj.id,{
          perid: this.edit_condi_perid,
          count: this.edit_condi_count,
          remark: this.edit_condi_remark,
          update_by: this.perid,
        }, headerAxios).then(res => {
          if (res.data.status) {
            this.getConditionData()
            this.edit_condi_perid = null
            this.edit_condi_count = ''
            this.edit_condi_remark = ''
            this.CondiDataObj = null
            this.dialogEditCondition = false
          }
        })
      }
    },
    editConditionData(item) {
      this.CondiDataObj = null
      this.CondiDataObj = item
      this.edit_condi_perid = item.perid
      this.edit_condi_count = parseInt(item.count)
      this.edit_condi_remark = item.remark
      this.dialogEditCondition = true
    },
    insertCondiCardData() {
      if (this.condi_perid == null && this.condi_count == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด บุคลากรและจำนวนบัตรที่ทำได้ ห้ามว่าง!!'
        })
      } else if (parseInt(this.condi_count) <= 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด โปรดตรวจสอบจำนวนบัตรที่ทำได้จะต้องมีค่ามากกว่า 0'
        })
      } else {
        const headerAxios = {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/condition/perid/' + this.condi_perid + '/active/1/?limit=1').then(res => {
          if (res.data) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลบุคลากรที่เลือกอยู่แล้ว !!'
            })
            this.condi_perid = null
          } else {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/condition/',{
              perid: this.condi_perid,
              count: this.condi_count,
              remark: this.condi_remark,
              create_by: this.perid,
              create_time: 'now()'
            }, headerAxios).then(res => {
              if (res.data.status) {
                this.getConditionData()
                this.condi_perid = null
                this.condi_count = ''
                this.condi_remark = ''
              }
            })
          }
        })
      }
    },
    deleteConditionData(item) {
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json',
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/condition/id/' + item.id,{
        active: '0',
        update_by: this.perid,
      }, headerAxios).then(res => {
        if (res.data.status) {
          this.getConditionData()
        }
      })
    },
    delRecript(item) {
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'DELETE'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/recript/id/' + item.id,'', headerAxios).then(res => {
        if (res.data.status) {
          this.GetRecript()
        }
      })
    },
    save (item) {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'

      this.headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/recript/id/' + item.id,{
        recript1: item.recript_no.split('-')[0],
        recript2: item.recript_no.split('-')[1],
        remark: item.remark,
        date: item.date,
        update_by: this.perid,
      },this.headerAxios).then(res => {
        if (res.data.status) {
          this.GetRecript()
        }
      })
    },
    cancel () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close () {
      console.log('Dialog closed')
    },
    DelPic(type) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "ต้องการลบข้อมูลดังกล่าว ใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/person_id/' + this.CardObj.person_id + '/attachment_types_id/' + type, {
            url: ''
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })

          switch (type) {
            case '1' :
              this.ImagePerson = ''
              this.ImagePersonType = ''
              break
            case '2' :
              this.ImagePersonCopy = ''
              this.ImagePersonCopyType = ''
              break
            case '3' :
              this.ImageRecript = ''
              this.ImageRecriptType = ''
              break
            case '4' :
              this.ImageHome = ''
              this.ImageHomeType = ''
              break
            default:
              break
          }
        }
      })
    },
    initFunc: function () {
      this.rows = []
      this.rowsBackup = []
      this.CardDataPerson = []
      var that = this
      this.getStaffData()
      this.getConditionData()
      axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
        queryName: 'PersonalDataByPerson',
        param: btoa(encodeURIComponent(JSON.stringify({
          perid: this.parseJwt(this.$cookies.get('access_token')).perid
        })))
      }).then(res => {
        if (res.data && res.data.staffData.length > 0) {
          this.peridAdmin = res.data.staffData[0].perid;
          this.nameAdmin = res.data.staffData[0].name
          this.surnameAdmin = res.data.staffData[0].surname
          this.depart = res.data.staffData[0].dep_name

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/depart_view/depart_types_id/2/PERID/' + this.perid).then(res => {
            if (res.data) {
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_types_id/2/?sort=id_DESC&limit=99999').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    res.data.map((element) => {
                      switch (element.request_types_id) {
                        case "2":
                          this.CardDataPerson.push(element)
                          break;
                        case "4":
                          this.CardDataPerson.push(element)
                          break;
                        default:
                          break;
                      }
                    })
                    this.CardDataPerson.forEach(function (item) {
                      switch (item.request_types_id) {
                        case "1":
                          item.Type = 'บุคลากร'
                          item.FullName = item.firstName + ' ' + item.lastName
                          break
                        case "2":
                          item.Type = 'ญาติ'
                          item.FullName = '<p style="font-weight: bold;font-size: 10px">' + item.firstName + ' ' + item.lastName + ' (' + item.perid + ')' + '</p>' +
                              '<p style="font-size: 10px;color: red">บัตรญาติ ' + that.CardDataPerson.filter(itemC => itemC.perid == item.perid && itemC.request_types_id == '2' && itemC.request_wish_id == '1' && itemC.status_id != '3').length + ' ใบ</p>'
                          break
                        case "4":
                          item.Type = 'ผู้ประกอบการ,ร้านค้า'
                          item.FullName = item.firstName + ' ' + item.lastName

                          break
                        default:
                          break
                      }
                      item.LicensePlate = item.license_plate + ' (' + item.name_in_thai + ')'
                      if (item.request_wish_id == '1') {
                        item.CardRequest = 'ใหม่'
                      } else if (item.request_wish_id == '2') {
                        item.CardRequest = 'หาย/ชำรุด'
                      } else if (item.request_wish_id == '4') {
                        item.CardRequest = 'ต่ออายุ'
                      }
                      item.DateShow = Vue.filter('DateToThaiManageCard')(item.create_date.split(' ')[0])
                    })
                  } else {
                    if (res.data.request_types_id == '2' || res.data.request_types_id == '4') {
                      this.CardDataPerson.push(res.data)
                      this.CardDataPerson.forEach(function (item) {
                        switch (item.request_types_id) {
                          case "1":
                            item.Type = 'บุคลากร'
                            item.FullName = item.firstName + ' ' + item.lastName

                            break
                          case "2":
                            item.Type = 'ญาติ'
                            item.FullName = '<p style="font-weight: bold;font-size: 10px">' + item.firstName + ' ' + item.lastName + ' (' + item.perid + ')' + '</p>' +
                                '<p style="font-size: 10px;color: red">บัตรญาติ ' + that.CardDataPerson.filter(itemC => itemC.perid == item.perid && itemC.request_types_id == '2' && itemC.request_wish_id == '1' && itemC.status_id != '3').length + ' ใบ</p>'
                            break
                          case "4":
                            item.Type = 'ผู้ประกอบการ,ร้านค้า'
                            item.FullName = item.firstName + ' ' + item.lastName

                            break
                          default:
                            break
                        }
                        item.LicensePlate = item.license_plate + ' (' + item.name_in_thai + ')'
                        if (item.request_wish_id == '1') {
                          item.CardRequest = 'ใหม่'
                        } else if (item.request_wish_id == '2') {
                          item.CardRequest = 'หาย/ชำรุด'
                        } else if (item.request_wish_id == '4') {
                          item.CardRequest = 'ต่ออายุ'
                        }
                        item.DateShow = Vue.filter('DateToThaiManageCard')(item.create_date.split(' ')[0])
                      })
                    }
                  }

                  // หาบัตร ผูิ้ประกอบการ
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request_view/request_types_id/4/?sort=id_DESC&limit=99999').then(res => {
                    if (res.data) {
                      if (res.data.length > 0) {
                        res.data.map((element) => {
                          switch (element.request_types_id) {
                            case "2":
                              this.CardDataPerson.push(element)
                              break;
                            case "4":
                              this.CardDataPerson.push(element)
                              break;
                            default:
                              break;
                          }
                        })
                        this.CardDataPerson.forEach(function (item) {
                          switch (item.request_types_id) {
                            case "1":
                              item.Type = 'บุคลากร'
                              item.FullName = item.firstName + ' ' + item.lastName
                              break
                            case "2":
                              item.Type = 'ญาติ'
                              item.FullName = '<p style="font-weight: bold;font-size: 10px">' + item.firstName + ' ' + item.lastName + ' (' + item.perid + ')' + '</p>' +
                                  '<p style="font-size: 10px;color: red">บัตรญาติ ' + that.CardDataPerson.filter(itemC => itemC.perid == item.perid && itemC.request_types_id == '2' && itemC.request_wish_id == '1' && itemC.status_id != '3').length + ' ใบ</p>'
                              break
                            case "4":
                              item.Type = 'ผู้ประกอบการ,ร้านค้า'
                              item.FullName = item.firstName + ' ' + item.lastName

                              break
                            default:
                              break
                          }
                          item.LicensePlate = item.license_plate + ' (' + item.name_in_thai + ')'
                          if (item.request_wish_id == '1') {
                            item.CardRequest = 'ใหม่'
                          } else if (item.request_wish_id == '2') {
                            item.CardRequest = 'หาย/ชำรุด'
                          } else if (item.request_wish_id == '4') {
                            item.CardRequest = 'ต่ออายุ'
                          }
                          item.DateShow = Vue.filter('DateToThaiManageCard')(item.create_date.split(' ')[0])
                        })
                      } else {
                        if (res.data.request_types_id == '2' || res.data.request_types_id == '4') {
                          this.CardDataPerson.push(res.data)
                          this.CardDataPerson.forEach(function (item) {
                            switch (item.request_types_id) {
                              case "1":
                                item.Type = 'บุคลากร'
                                item.FullName = item.firstName + ' ' + item.lastName
                                break
                              case "2":
                                item.Type = 'ญาติ'
                                item.FullName = '<p style="font-weight: bold;font-size: 10px">' + item.firstName + ' ' + item.lastName + ' (' + item.perid + ')' + '</p>' +
                                    '<p style="font-size: 10px;color: red">บัตรญาติ ' + that.CardDataPerson.filter(itemC => itemC.perid == item.perid && itemC.request_types_id == '2' && itemC.request_wish_id == '1' && itemC.status_id != '3').length + ' ใบ</p>'
                                break
                              case "4":
                                item.Type = 'ผู้ประกอบการ,ร้านค้า'
                                item.FullName = item.firstName + ' ' + item.lastName

                                break
                              default:
                                break
                            }
                            item.LicensePlate = item.license_plate + ' (' + item.name_in_thai + ')'
                            if (item.request_wish_id == '1') {
                              item.CardRequest = 'ใหม่'
                            } else if (item.request_wish_id == '2') {
                              item.CardRequest = 'หาย/ชำรุด'
                            } else if (item.request_wish_id == '4') {
                              item.CardRequest = 'ต่ออายุ'
                            }
                            item.DateShow = Vue.filter('DateToThaiManageCard')(item.create_date.split(' ')[0])
                          })
                        }
                      }

                      const status1 = this.CardDataPerson.filter(item => item.status_id == 0)
                      const status2 = this.CardDataPerson.filter(item => item.status_id == 2)
                      const status3 = this.CardDataPerson.filter(item => item.status_id == 3)
                      const status4 = this.CardDataPerson.filter(item => item.status_id == 4)
                      const status5 = this.CardDataPerson.filter(item => item.status_id == 5)
                      const status6 = this.CardDataPerson.filter(item => item.status_id == 6)
                      this.CardDataPerson = status1.concat(status2, status3, status4, status5, status6)
                      this.rows = this.CardDataPerson
                      this.CountTypeAll = this.rows.length
                      this.CountType2 = this.rows.filter(itemR => itemR.request_types_id == '2')
                      this.CountType4 = this.rows.filter(itemR => itemR.request_types_id == '4')
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่มีข้อมูลการทำบัตร'
                      })
                    }
                  })

                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'ไม่มีข้อมูลการทำบัตร'
                  })
                }
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/provinces_view/?limit=9999').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.ProviceData = res.data
                  } else {
                    this.ProviceData.push(res.data)
                  }
                } else {
                  this.ProviceData = []
                }
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms_view/is_used/1').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.optionsSelect = res.data
                  } else {
                    this.optionsSelect.push(res.data)
                  }
                } else {
                  this.optionsSelect = []
                }
              })
              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms/is_used/1').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.relationshipData = res.data
                  } else {
                    this.relationshipData.push(res.data)
                  }
                } else {
                  this.relationshipData = []
                }
              })

            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'คุณไม่ได้รับสิทธิในการจัดการข้อมูล'
              })
              this.$router.push('/')
            }
          })
        }
      })
    },
    ShowCardAll(item) {
      this.namePerson = ''
      this.cardHistoryObj = null
      this.cardHistoryObj = item
      this.CardHistoryDetail = []
      this.CardHistoryDetail = item.Type == 'ญาติ' ? this.CardDataPerson.filter(itemC => itemC.perid == item.perid)  : this.CardDataPerson.filter(itemC => itemC.citizenId == item.citizenId)
      if (this.CardHistoryDetail.length > 0) {
        if (item.Type == 'ญาติ') {
          axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
            queryName: 'PersonalDataByPerson',
            param: btoa(encodeURIComponent(JSON.stringify({
              perid: item.perid
            })))
          }).then(res => {
            if (res.data && res.data.staffData.length > 0) {
              this.namePerson = res.data.staffData[0].name + ' ' + res.data.staffData[0].surname;
            }
          })
        } else {
          this.namePerson = item.citizenId
        }
        this.dialogShowCardHis = true
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'ไม่พบข้อมูลประวัติการทำบัตรญาติ !!'
        })
      }
    },
    GetRecript() {
      this.RecriptData = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/recript/person_id/' + this.CardObj.person_id + '/?limit=9999/').then(res => {
        if (res.data) {
          if(res.data.length > 0) {
            this.RecriptData = res.data
          } else {
            this.RecriptData.push(res.data)
          }
          this.RecriptData.map(item => {
            item.recript_no = item.recript1 + '-' + item.recript2
          })
        } else {
          this.RecriptData = []
        }
      })
    },
    ReCheckDupeRecript() {
      this.CheckRecript = false
      this.ReCheckRecript = []
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/recript_view/recript1/' + this.recript1 + '/recript2/' + this.recript2).then(res => {
        if (res.data) {
          if(res.data.length > 0) {
            this.ReCheckRecript = res.data
          } else {
            this.ReCheckRecript.push(res.data)
          }
          this.ReCheckRecript.map(item => {
            item.recript_no = item.recript1 + '-' + item.recript2
          })
          this.CheckRecript = true
        } else {
          this.ReCheckRecript = []
          this.CheckRecript = true
        }
      })
    },
    saveRecript() {
      this.headerAxios = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/recript/',{
        recript1: this.recript1,
        recript2: this.recript2,
        remark: this.remark,
        date: this.date,
        person_id: this.CardObj.person_id,
        create_by: this.perid,
        create_time: 'now()'
      },this.headerAxios).then(res => {
        if (res.data.status) {
          this.$swal.fire({
            icon: 'success',
            title: 'บันทึกข้อมูลสำเร็จ',
          })
          this.recript1 = ''
          this.recript2 = ''
          this.remark = ''
          this.ReCheckRecript = []
          this.CheckRecript = false
          this.GetRecript()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถทำรายการได้สำเร็จ โปรดลองอีกครั้ง'
          })
        }
      })
    },
    GetDormHis() {
      this.dormData = []
      axios.get('https://medppss.medicine.psu.ac.th/api/dome//PP3S/dormmed/dorm/person_id/' + this.perid).then(res => {
        if (res.data.data.length > 0) {
          this.dormData = res.data.data
        }
      })
    },
    downloadItem() {
      axios.get(this.ImagePerson, {responseType: 'blob'})
          .then(response => {

            const url = new Blob([response.data], {type: 'application/zip'});
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.zip');
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href)

            // const blob = new Blob([response.data], { type: 'image/jpg' })
            // const link = document.createElement('a')
            // link.href = URL.createObjectURL(blob)
            // link.download = this.perid + '.jpg'
            // link.click()
            // URL.revokeObjectURL(link.href)

            /*var param = {
                'is_used': '0'
            }
            this.headerAxios = {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms/id/' + ShopObj.id, param, this.headerAxios).then(res => {
                if (res.data.status) {

                }
            })*/

          }).catch(console.error)
    },
    onScroll(e) {
      this.scrollPosition = e.target.scrollTop
    },
    showDetailsFunc: function (Card_Data) {
      this.dialogShowCardHis = false
      if (this.ShowDetails) {
        this.CardObj = null
        this.ShowDetails = false

        this.DateExpire = ''
        this.perid = ''
        this.nameTh = ''
        this.surnameTh = ''
        this.brithDay = ''
        this.gender = ''
        this.phoneDepart = ''
        this.phoneMoblie = ''
        this.phoneHome = ''
        this.email = ''
        this.address = ''
        this.dorm = ''
        this.dorm2 = ''
        this.ApproveDetail = ''
        this.vehicleReg = ''
        this.vehicleRegProvice = ''
        this.adult_name = ''
        this.relationship = ''
        this.shop_type_id = ''
        this.shop_name = ''
        this.ImagePerson = ''
        this.ImagePersonCopy = ''
        this.ImageRecript = ''
        this.ImageHome = ''
        this.backGround = {
          'background-color': '#8c8c8c'
        }
        this.attachment_data = []
        this.contactData = []
        this.status = ''
        this.ChkImageHome = false
        this.ChkImagePerson = false
        this.ChkImagePersonCopy = false
        this.ChkImageRecript = false

        this.RecriptData = []
        this.ReCheckRecript = []
        this.CheckRecript = false

        this.$vuetify.goTo(this.scrollPosition)

      } else {

        /* if (typeof window != 'undefined') {
             const top = window.pageYOffset || e.target.scrollTop || 0
             this.scrollPosition = top
         }*/

        this.$vuetify.goTo(300)
        this.ShowDetails = true

        this.CardObj = Card_Data
        this.DateExpire = Card_Data.expire_date
        this.perid = Card_Data.perid
        this.nameTh = Card_Data.firstName
        this.surnameTh = Card_Data.lastName
        this.brithDay = Card_Data.birthdate
        this.shop_name = Card_Data.shopname
        this.shop_type_id = Card_Data.shop_type_id
        this.idcard = Card_Data.citizenId
        this.ApproveDetail = Card_Data.comment
        this.vehicleReg = Card_Data.license_plate
        this.vehicleRegProvice = Card_Data.provinces_id
        this.adult_name = Card_Data.adult_name
        this.relationship = Card_Data.relationship_id
        this.status = Card_Data.status_id

        if (Card_Data.sex == 'M') {
          this.gender = 'ชาย'
        } else {
          this.gender = 'หญิง'
        }

        if (Card_Data.request_types_id == '2') {
          this.showPage = '2'
          this.backGround = {
            'background-color': '#fc8006'
          }
        } else {
          this.showPage = '4'
          this.backGround = {
            'background-color': '#fe1800'
          }
        }

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms/id/' + Card_Data.shop_type_id).then(shopData => {
          if (shopData) {
            if (shopData.data.length > 0) {
              shopData.data.map((ele) => {
                if (ele.id == Card_Data.shop_type_id) {
                  this.shop_type_id = ele.id
                  this.shop_type = ele.id
                  this.ShopShow = ele.type_name
                }
              })
            } else {
              this.shop_type_id = shopData.data.id
              this.shop_type = shopData.data.id
              this.ShopShow = shopData.data.type_name
            }
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่พบข้อมูลประเภทการลา โปรดติดต่อ ผู้ดูแลระบบ'
            })
          }
        })

        // axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/dorm_view/person_id/' + Card_Data.person_id).then(personV => {
        //     if (personV.data) {
        //         this.dorm = personV.data[0].value
        //         this.dorm2 = personV.data[1].value
        //     }
        // })

        axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
          queryName: 'PersonalDataByPerson',
          param: btoa(encodeURIComponent(JSON.stringify({
            perid: Card_Data.perid
          })))
        }).then(res => {
          if (res.data && res.data.staffData.length > 0) {
            if (res.data.dormData != null && res.data.dormData.length > 0) {
              this.dorm = res.data.dormData[0].room_name
              this.dorm2 = res.data.dormData[0].dorm_name
            }
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact_view/request_id/' + Card_Data.id).then(contactV => {
          if (contactV.data) {
            this.contactData = contactV.data
            this.email = contactV.data[0].value
            this.address = contactV.data[5].value
            this.phoneDepart = contactV.data[2].value
            this.phoneMoblie = contactV.data[3].value
            this.phoneHome = contactV.data[4].value
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment_view/person_id/' + Card_Data.person_id).then(res => {
          if (res.data) {
            this.attachment_data = res.data
            switch (res.data[0].url.split('.')[1]) {
              case 'jpg':
              case 'jpeg':
              case 'gif':
              case 'bmp':
              case 'png':
                this.ImagePersonType = true
                this.pdfPersonType = false
                this.ImagePerson = ConstData.ConnectionHost + '/rest/files/' + res.data[0].url
                break
              case 'pdf':
                this.pdfPersonType = true
                this.ImagePersonType = false
                this.ImagePerson = ConstData.ConnectionHost + '/rest/files/' + res.data[0].url
                break
              default:
                this.ImagePersonType = false
                this.pdfPersonType = false
                this.ImagePerson = ''
                break
            }

            switch (res.data[1].url.split('.')[1]) {
              case 'jpg':
              case 'jpeg':
              case 'gif':
              case 'bmp':
              case 'png':
                this.ImagePersonCopyType = true
                this.pdfPersonCopyType = false
                this.ImagePersonCopy = ConstData.ConnectionHost + '/rest/files/' + res.data[1].url
                break
              case 'pdf':
                this.pdfPersonCopyType = true
                this.ImagePersonCopyType = false
                this.ImagePersonCopy = ConstData.ConnectionHost + '/rest/files/' + res.data[1].url
                break
              default:
                this.ImagePersonCopyType = false
                this.pdfPersonCopyType = false
                this.ImagePersonCopy = ''
                break
            }

            switch (res.data[2].url.split('.')[1]) {
              case 'jpg':
              case 'jpeg':
              case 'gif':
              case 'bmp':
              case 'png':
                this.ImageRecriptType = true
                this.pdfRecriptType = false
                this.ImageRecript = ConstData.ConnectionHost + '/rest/files/' + res.data[2].url
                break
              case 'pdf':
                this.pdfRecriptType = true
                this.ImageRecriptType = false
                this.ImageRecript = ConstData.ConnectionHost + '/rest/files/' + res.data[2].url
                break
              default:
                this.ImageRecriptType = false
                this.pdfRecriptType = false
                this.ImageRecript = ''
                break
            }

            switch (res.data[3].url.split('.')[1]) {
              case 'jpg':
              case 'jpeg':
              case 'gif':
              case 'bmp':
              case 'png':
                this.ImageHomeType = true
                this.pdfHomeType = false
                this.ImageHome = ConstData.ConnectionHost + '/rest/files/' + res.data[3].url
                break
              case 'pdf':
                this.pdfHomeType = true
                this.ImageHomeType = false
                this.ImageHome = ConstData.ConnectionHost + '/rest/files/' + res.data[3].url
                break
              default:
                this.ImageHomeType = false
                this.pdfHomeType = false
                this.ImageHome = ''
                break
            }
          }
        })

        axios.get(ConstData.ConnectionHostPerson + '/profile/' + Card_Data.perid + '/info').then(res => {
          if (res.data.data) {
            this.namePerson = res.data.data.fullname[1];
          }
        })

        this.GetRecript()
      }
    },
    ChangeStatus: function (Cordi, ShopObj) {
      if (Cordi == 0) {
        var param = {
          'is_used': '0'
        }
        this.headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms/id/' + ShopObj.id, param, this.headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms').then(res => {
              if (res.data) {
                this.ShopMs = []
                if (res.data.length > 0) {
                  this.ShopMs = res.data
                } else {
                  this.ShopMs.push(res.data)
                }
              } else {
                this.ShopMs = []
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถเปลื่ยนแปลงข้อมูลได้'
            })
          }
        });
      } else {
        param = {
          'is_used': '1'
        }
        this.headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms/id/' + ShopObj.id, param, this.headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms').then(res => {
              if (res.data) {
                this.ShopMs = []
                if (res.data.length > 0) {
                  this.ShopMs = res.data
                } else {
                  this.ShopMs.push(res.data)
                }
              } else {
                this.ShopMs = []
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถเปลื่ยนแปลงข้อมูลได้'
            })
          }
        });
      }
    },
    ChangeStatusRelation: function (Cordi, RelationObj) {
      if (Cordi == 0) {
        var param = {
          'is_used': '0'
        }
        this.headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms/id/' + RelationObj.id, param, this.headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms').then(res => {
              if (res.data) {
                this.relationship_ms = []
                if (res.data.length > 0) {
                  this.relationship_ms = res.data
                } else {
                  this.relationship_ms.push(res.data)
                }
              } else {
                this.relationship_ms = []
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถเปลื่ยนแปลงข้อมูลได้'
            })
          }
        });
      } else {
        param = {
          'is_used': '1'
        }
        this.headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms/id/' + RelationObj.id, param, this.headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms').then(res => {
              if (res.data) {
                this.relationship_ms = []
                if (res.data.length > 0) {
                  this.relationship_ms = res.data
                } else {
                  this.relationship_ms.push(res.data)
                }
              } else {
                this.relationship_ms = []
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถเปลื่ยนแปลงข้อมูลได้'
            })
          }
        });
      }
    },
    ChangeStatusPermiss: function (Cordi, PermissObj) {
      if (Cordi == 0) {
        var param = {
          'active': '0'
        }
        this.headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative/id/' + PermissObj.id, param, this.headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative_view').then(res => {
              if (res.data) {
                this.permiss_relative = []
                if (res.data.length > 0) {
                  this.permiss_relative = res.data
                } else {
                  this.permiss_relative.push(res.data)
                }
              } else {
                this.permiss_relative = []
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถเปลื่ยนแปลงข้อมูลได้'
            })
          }
        });
      } else {
        param = {
          'active': '1'
        }
        this.headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative/id/' + PermissObj.id, param, this.headerAxios).then(res => {
          if (res.data.status) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative_view').then(res => {
              if (res.data) {
                this.permiss_relative = []
                if (res.data.length > 0) {
                  this.permiss_relative = res.data
                } else {
                  this.permiss_relative.push(res.data)
                }
              } else {
                this.permiss_relative = []
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สามารถเปลื่ยนแปลงข้อมูลได้'
            })
          }
        });
      }
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    ChooseApprove: function () {
      if (this.Approve) {
        this.Approve = false
      } else {
        this.Approve = true
      }
    },
    PayCard: function () {
      var param = {
        'status_id': '5'
      }
      this.headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request/id/' + this.CardObj.id, param, this.headerAxios).then(res => {
        if (res.data.status) {
          this.$swal.fire({
            icon: 'success',
            title: 'บันทึกข้อมูลสำเร็จ',
          })
          this.ShowDetails = false

          this.DateExpire = ''
          this.perid = ''
          this.nameTh = ''
          this.surnameTh = ''
          this.brithDay = ''
          this.gender = ''
          this.phoneDepart = ''
          this.phoneMoblie = ''
          this.phoneHome = ''
          this.email = ''
          this.address = ''
          this.dorm = ''
          this.dorm2 = ''
          this.ApproveDetail = ''
          this.vehicleReg = ''
          this.vehicleRegProvice = ''
          this.adult_name = ''
          this.relationship = ''
          this.shop_type_id = ''
          this.ImagePerson = ''
          this.ImagePersonCopy = ''
          this.ImageRecript = ''
          this.ImageHome = ''

          this.CardDataPerson = []
          this.rows = []
          this.initFunc()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถยันทึกข้อมูลได้'
          })
        }
      });
    },
    ApproveData: function () {
      var param = {
        'status_id': this.status
      }
      this.headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request/id/' + this.CardObj.id, param, this.headerAxios).then(async res => {
        if (res.data.status) {

          var param = {
            'comment': this.ApproveDetail
          }

          this.headerAxios2 = {
            headers: {
              'Content-Type': 'application/json'
            }
          }

          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request/id/' + this.CardObj.id, param, this.headerAxios2).then(resPut => {
            if (resPut.data.status) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/log_approve', {
                request_id: this.CardObj.id,
                status: this.status,
                comment: this.ApproveDetail,
                create_by: this.peridAdmin,
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              })
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ',
              })
              this.ShowDetails = false

              this.DateExpire = ''
              this.perid = ''
              this.nameTh = ''
              this.surnameTh = ''
              this.brithDay = ''
              this.gender = ''
              this.phoneDepart = ''
              this.phoneMoblie = ''
              this.phoneHome = ''
              this.email = ''
              this.address = ''
              this.dorm = ''
              this.dorm2 = ''
              this.ApproveDetail = ''
              this.vehicleReg = ''
              this.vehicleRegProvice = ''
              this.adult_name = ''
              this.relationship = ''
              this.shop_type_id = ''
              this.ImagePerson = ''
              this.ImagePersonCopy = ''
              this.ImageRecript = ''
              this.ImageHome = ''

              this.CardDataPerson = []
              this.rows = []
              this.initFunc()
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถยันทึกข้อมูลได้'
              })
            }
          })
        }
      })
    },
    blackMenu: function () {
      this.$router.push('/')
    },
    SwitchMenu: function (Cordi) {
      if (Cordi == '1') {
        this.manageMenu = '1';

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms').then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              this.ShopMs = res.data
            } else {
              this.ShopMs.push(res.data)
            }
          } else {
            this.ShopMs = []
          }
        })
      } else if (Cordi == '2') {
        this.manageMenu = '2';

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms').then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              this.relationship_ms = res.data
            } else {
              this.relationship_ms.push(res.data)
            }
          } else {
            this.relationship_ms = []
          }
        })
      } else if (Cordi == '3') {
        this.manageMenu = '3';
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative_view').then(res => {
          if (res.data) {
            this.permiss_relative = []
            if (res.data.length > 0) {
              this.permiss_relative = res.data
            } else {
              this.permiss_relative.push(res.data)
            }
          } else {
            this.permiss_relative = []
          }
        })
      } else {
        this.manageMenu = '0';
        this.ShopMs = []
        this.relationship_ms = []
      }
    },
    insertData: function () {

      this.$swal.fire({
        title: 'ต้องการเพิ่มประเภทร้านค้า ' + this.typeShop + ' ใช่หรือไม่',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          var param = {
            'id': this.ShopMs.length + 1,
            'type_name': this.typeShop,
            'is_used': '1'
          }

          this.headerAxios2 = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          }

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms', param, this.headerAxios2).then(resPut => {
            if (resPut.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ',
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.ShopMs = res.data
                  } else {
                    this.ShopMs.push(res.data)
                  }
                } else {
                  this.ShopMs = []
                }
              })

              this.typeShop = ''
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถยันทึกข้อมูลได้'
              })

              this.typeShop = ''
            }
          })
        }
      })


    },
    deleteData: function (dataParam) {

      this.$swal.fire({
        title: 'ต้องการลบประเภทร้านค้า ' + dataParam.type_name + ' ใช่หรือไม่',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {


          var param = {
            'id': this.typeShop.length + 1,
            'type_name': this.typeShop
          }

          this.headerAxios2 = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms/id/' + dataParam.id, param, this.headerAxios2).then(resPut => {
            this.ShopMs = []
            if (resPut.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ',
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop_ms').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.ShopMs = res.data
                  } else {
                    this.ShopMs.push(res.data)
                  }
                } else {
                  this.ShopMs = []
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถลบข้อมูลได้'
              })
            }
          })
        }
      })


    },
    insertDataRelation: function () {

      this.$swal.fire({
        title: 'ต้องการเพิ่มประเภทความสัมพันธ์ ' + this.typeShop + ' ใช่หรือไม่',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          var param = {
            'id': this.relationship_ms.length + 1,
            'relationship': this.typeRelation,
            'is_used': '1'
          }

          this.headerAxios2 = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          }

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms', param, this.headerAxios2).then(resPut => {
            if (resPut.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ',
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.relationship_ms = res.data
                  } else {
                    this.relationship_ms.push(res.data)
                  }
                } else {
                  this.relationship_ms = []
                }
              })

              this.typeRelation = ''
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถยันทึกข้อมูลได้'
              })

              this.typeRelation = ''
            }
          })
        }
      })


    },
    insertPersonPermiss: function () {
      this.$swal.fire({
        title: 'ต้องการเพิ่มข้อมูลบุคลากรในการทำบัตรญาติ รหัส : ' + this.uid + ' ใช่หรือไม่',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          var param = {
            'perid': this.uid,
            'active': '1'
          }

          this.headerAxios2 = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          }

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative', param, this.headerAxios2).then(resPut => {
            if (resPut.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ',
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative_view').then(res => {
                if (res.data) {
                  this.permiss_relative = []
                  if (res.data.length > 0) {
                    this.permiss_relative = res.data
                  } else {
                    this.permiss_relative.push(res.data)
                  }
                } else {
                  this.permiss_relative = []
                }
              })

              this.uid = ''
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถยันทึกข้อมูลได้'
              })

              this.uid = ''
            }
          })
        }
      })


    },
    deleteDataRelation: function (dataParam) {

      this.$swal.fire({
        title: 'ต้องการลบประเภทความสัมพันธ์ ' + dataParam.type_name + ' ใช่หรือไม่',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {

          this.headerAxios2 = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms/id/' + dataParam.id, '', this.headerAxios2).then(resPut => {
            this.relationship_ms = []
            if (resPut.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ',
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/relationship_ms').then(res => {
                if (res.data) {
                  if (res.data.length > 0) {
                    this.relationship_ms = res.data
                  } else {
                    this.relationship_ms.push(res.data)
                  }
                } else {
                  this.relationship_ms = []
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถลบข้อมูลได้'
              })
            }
          })
        }
      })
    },
    deleteDataPermiss: function (dataParam) {
      this.$swal.fire({
        title: "ต้องการลบข้อมูลการทำบัตรคุณ : " + dataParam.full_Name + ' ใช่หรือไม่ ?',
        text: "",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {

          this.headerAxios2 = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative/id/' + dataParam.id, '', this.headerAxios2).then(resPut => {
            if (resPut.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ',
              })

              axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/permiss_relative_view').then(res => {
                if (res.data) {
                  this.permiss_relative = []
                  if (res.data.length > 0) {
                    this.permiss_relative = res.data
                  } else {
                    this.permiss_relative.push(res.data)
                  }
                } else {
                  this.permiss_relative = []
                }
              })

              this.uid = ''
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถลบข้อมูลได้'
              })

              this.uid = ''
            }
          })
        }
      })
    },
    rotate() {
      var image = document.createElement("img");
      image.crossOrigin = "anonymous";
      image.src = this.pic_Profile;
      image.onload = () => {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        if (image.width > image.height) {
          canvas.width = image.height;
          canvas.height = image.width;
          ctx.translate(image.height, image.width / image.height);
        } else {
          canvas.height = image.width;
          canvas.width = image.height;
          ctx.translate(image.height, image.width / image.height);
        }
        ctx.rotate(Math.PI / 2);
        ctx.drawImage(image, 0, 0);
        this.pic_Profile = canvas.toDataURL();
      };
    },
    onChangePic({coordinates, canvas}) {

      this.coordinates = coordinates
      // You able to do different manipulations at a canvas
      // but there we just get a cropped image
      this.imageCrop = canvas.toDataURL("image/png")
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
      else
        byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type: mimeString});
    },
    pixelsRestriction({minWidth, minHeight, maxWidth, maxHeight}) {
      return {
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
      }
    },
    DeleteCardItem(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "ต้องการลบข้อมูลการทำบัตรคุณ : " + item.firstName + ' ' + item.lastName + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              // 'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/request/id/' + item.id, {
            active: '0'
          }, this.headerAxios).then(res => {
            if (res.data.status) {
              this.dialogShowCardHis = false
              this.initFunc()
              this.ChooseCardType()
              this.$swal.fire({
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ'
              })
            }
            this.headerAxios = {
              headers: {
                'Content-Type': 'application/json',
              }
            }
          })
        }
      })
    },
    SubmitForm: function () {
      var count = 0
      var shopData = []
      this.CheckSubmit = true
      if (this.idcard.length != 13) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'คุณกรอกเลขบัตรประชาชนไม่ถูกต้อง กรุณากรอกอีกครั้ง'
        })
        this.idcard = ''
      } else {
        if (this.CardObj.request_types_id == '2') {
          if (this.ChkImagePerson) {
            var blobImage = this.dataURItoBlob(this.imageCrop)
            // this.imageCrop = canvas.toD  ataURL()

            const fd = new FormData()
            fd.append('file', blobImage, this.ImageName)
            this.headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, this.headerAxios).then(res => {
              if (res.data.status) {

                this.selectFile = res.data.path

                this.dataFormSubmit.items[0].person.perid = this.perid;
                this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                this.dataFormSubmit.items[0].person.birthdate = this.brithDay
                this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
                this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
                this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

                this.headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }

                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/person/id/' + this.CardObj.person_id, this.dataFormSubmit.items[0].person, this.headerAxios).then(res => {
                  if (res.data.status) {
                    this.contactData.map((element, idxContact) => {
                      switch (element.contact_types_id) {
                        case "1":
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                            value: this.$data.email
                          }, this.headerAxios)
                          break;
                        case "2":
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                            value: this.$data.depart
                          }, this.headerAxios)
                          break;
                        case "3":
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                            value: this.$data.phoneDepart
                          }, this.headerAxios)
                          break;
                        case "4":
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                            value: this.$data.phoneMoblie
                          }, this.headerAxios)
                          break;
                        case "5":
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                            value: this.$data.phoneHome
                          }, this.headerAxios)
                          break;
                        default:
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                            value: this.$data.address
                          }, this.headerAxios)
                          break;
                      }

                      if (idxContact == this.contactData.length - 1) {
                        this.attachment_data.map((attachmentData) => {
                          switch (attachmentData.attachment_types_id) {
                            case "1":
                              if (this.ChkImagePerson) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                  url: this.selectFile
                                }, this.headerAxios).then(res => {
                                  if (res.data.status) {
                                    count++
                                    if (count == this.attachment_data.length - 1) {
                                      this.CheckSubmit = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                    }
                                  }
                                })
                              } else {
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                              }
                              break;
                            case "2" :
                              if (this.ChkImagePersonCopy) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                  url: this.FilePersonal
                                }, this.headerAxios).then(res => {
                                  if (res.data.status) {
                                    count++
                                    if (count == this.attachment_data.length - 1) {
                                      this.CheckSubmit = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                    }
                                  }
                                })
                              } else {
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                              }
                              break;
                            case "3" :
                              if (this.ChkImageRecript) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                  url: this.FileRecript
                                }, this.headerAxios).then(res => {
                                  if (res.data.status) {
                                    count++
                                    if (count == this.attachment_data.length - 1) {
                                      this.CheckSubmit = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                    }
                                  }
                                })
                              } else {
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                              }
                              break;
                            case "4" :
                              if (this.ChkImageHome) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                  url: this.FileHome
                                }, this.headerAxios).then(res => {
                                  if (res.data.status) {
                                    count++
                                    if (count == this.attachment_data.length - 1) {
                                      this.CheckSubmit = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                    }
                                  }
                                })
                              } else {
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                              }
                              break;
                            default :
                              count++
                              if (count == this.attachment_data.length - 1) {
                                this.CheckSubmit = false
                                this.$swal.fire({
                                  icon: 'success',
                                  title: 'บันทึกข้อมูลสำเร็จ'
                                })
                              }
                              break;
                          }
                        })
                      }
                    })
                  }
                })
              } else {
                this.selectFile = ''
              }
            })
          } else {
            this.dataFormSubmit.items[0].person.perid = this.perid;
            this.dataFormSubmit.items[0].person.citizenId = this.idcard;
            this.dataFormSubmit.items[0].person.firstName = this.nameTh;
            this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
            this.dataFormSubmit.items[0].person.birthdate = this.brithDay
            this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
            this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
            this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

            this.headerAxios = {
              headers: {
                'Content-Type': 'application/json',
              }
            }

            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/person/id/' + this.CardObj.person_id, this.dataFormSubmit.items[0].person, this.headerAxios).then(res => {
              if (res.data.status) {
                this.contactData.map((element, idxContact) => {
                  switch (element.contact_types_id) {
                    case "1":
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                        value: this.$data.email
                      }, this.headerAxios)
                      break;
                    case "2":
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                        value: this.$data.depart
                      }, this.headerAxios)
                      break;
                    case "3":
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                        value: this.$data.phoneDepart
                      }, this.headerAxios)
                      break;
                    case "4":
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                        value: this.$data.phoneMoblie
                      }, this.headerAxios)
                      break;
                    case "5":
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                        value: this.$data.phoneHome
                      }, this.headerAxios)
                      break;
                    default:
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                        value: this.$data.address
                      }, this.headerAxios)
                      break;
                  }

                  if (idxContact == this.contactData.length - 1) {
                    this.attachment_data.map((attachmentData) => {
                      switch (attachmentData.attachment_types_id) {
                        case "1":
                          count++
                          if (count == this.attachment_data.length - 1) {
                            this.CheckSubmit = false
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                          break;
                        case "2" :
                          if (this.ChkImagePersonCopy) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                              url: this.FilePersonal
                            }, this.headerAxios).then(res => {
                              if (res.data.status) {
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                              }
                            })
                          } else {
                            count++
                            if (count == this.attachment_data.length - 1) {
                              this.CheckSubmit = false
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                            }
                          }
                          break;
                        case "3" :
                          if (this.ChkImageRecript) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                              url: this.FileRecript
                            }, this.headerAxios).then(res => {
                              if (res.data.status) {
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                              }
                            })
                          } else {
                            count++
                            if (count == this.attachment_data.length - 1) {
                              this.CheckSubmit = false
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                            }
                          }
                          break;
                        case "4" :
                          if (this.ChkImageHome) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                              url: this.FileHome
                            }, this.headerAxios).then(res => {
                              if (res.data.status) {
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                              }
                            })
                          } else {
                            count++
                            if (count == this.attachment_data.length - 1) {
                              this.CheckSubmit = false
                              this.$swal.fire({
                                icon: 'success',
                                title: 'บันทึกข้อมูลสำเร็จ'
                              })
                            }
                          }
                          break;
                        default :
                          count++
                          if (count == this.attachment_data.length - 1) {
                            this.CheckSubmit = false
                            this.$swal.fire({
                              icon: 'success',
                              title: 'บันทึกข้อมูลสำเร็จ'
                            })
                          }
                          break;
                      }
                    })
                  }
                })
              }
            })
          }
        } else {
          if (this.ChkImagePerson) {
            blobImage = this.dataURItoBlob(this.imageCrop)
            // this.imageCrop = canvas.toDataURL()

            const fd = new FormData()
            fd.append('file', blobImage, this.ImageName)
            this.headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, this.headerAxios).then(res => {
              if (res.data.status) {

                this.selectFile = res.data.path

                this.dataFormSubmit.items[0].person.citizenId = this.idcard;
                this.dataFormSubmit.items[0].person.firstName = this.nameTh;
                this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
                this.dataFormSubmit.items[0].person.birthdate = this.brithDay
                this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
                this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
                this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

                this.headerAxios = {
                  headers: {
                    'Content-Type': 'application/json',
                  }
                }

                if (this.shop_type == '27') {
                  shopData = this.optionsSelect.filter(shop => shop.id == this.shop_type)

                  this.dataFormSubmit.items[0].shop[0].shop_name = this.shop_name
                  this.dataFormSubmit.items[0].shop[0].shop_type_id = shopData[0].id

                  this.dataFormSubmit.items[0].adult[0].adult_name = this.adult_name
                  this.dataFormSubmit.items[0].adult[0].relationship_id = this.relationship

                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop/request_id/' + this.CardObj.id, this.dataFormSubmit.items[0].shop[0], this.headerAxios).then(resShop => {
                    if (resShop.data.status) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/adult/request_id/' + this.CardObj.id, this.dataFormSubmit.items[0].adult[0], this.headerAxios).then(resRelation => {
                        if (resRelation.data.status) {
                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/person/id/' + this.CardObj.person_id, this.dataFormSubmit.items[0].person, this.headerAxios).then(res => {
                            if (res.data.status) {
                              this.contactData.map((element, idxContact) => {
                                switch (element.contact_types_id) {
                                  case "1":
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                      value: this.$data.email
                                    }, this.headerAxios)
                                    break;
                                  case "2":
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                      value: this.$data.depart
                                    }, this.headerAxios)
                                    break;
                                  case "3":
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                      value: this.$data.phoneDepart
                                    }, this.headerAxios)
                                    break;
                                  case "4":
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                      value: this.$data.phoneMoblie
                                    }, this.headerAxios)
                                    break;
                                  case "5":
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                      value: this.$data.phoneHome
                                    }, this.headerAxios)
                                    break;
                                  default:
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                      value: this.$data.address
                                    }, this.headerAxios)
                                    break;
                                }

                                if (idxContact == this.contactData.length - 1) {
                                  this.attachment_data.map((attachmentData) => {
                                    switch (attachmentData.attachment_types_id) {
                                      case "1":
                                        if (this.ChkImagePerson) {
                                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                            url: this.selectFile
                                          }, this.headerAxios).then(res => {
                                            if (res.data.status) {
                                              count++
                                              if (count == this.attachment_data.length - 1) {
                                                this.CheckSubmit = false
                                                this.$swal.fire({
                                                  icon: 'success',
                                                  title: 'บันทึกข้อมูลสำเร็จ'
                                                })
                                              }
                                            }
                                          })
                                        } else {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                        break;
                                      case "2" :
                                        if (this.ChkImagePersonCopy) {
                                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                            url: this.selectFile
                                          }, this.headerAxios).then(res => {
                                            if (res.data.status) {
                                              count++
                                              if (count == this.attachment_data.length - 1) {
                                                this.CheckSubmit = false
                                                this.$swal.fire({
                                                  icon: 'success',
                                                  title: 'บันทึกข้อมูลสำเร็จ'
                                                })
                                              }
                                            }
                                          })
                                        } else {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                        break;
                                      case "3" :
                                        if (this.ChkImageRecript) {
                                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                            url: this.FileRecript
                                          }, this.headerAxios).then(res => {
                                            if (res.data.status) {
                                              count++
                                              if (count == this.attachment_data.length - 1) {
                                                this.CheckSubmit = false
                                                this.$swal.fire({
                                                  icon: 'success',
                                                  title: 'บันทึกข้อมูลสำเร็จ'
                                                })
                                              }
                                            }
                                          })
                                        } else {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                        break;
                                      case "4" :
                                        if (this.ChkImageHome) {
                                          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                            url: this.FileHome
                                          }, this.headerAxios).then(res => {
                                            if (res.data.status) {
                                              count++
                                              if (count == this.attachment_data.length - 1) {
                                                this.CheckSubmit = false
                                                this.$swal.fire({
                                                  icon: 'success',
                                                  title: 'บันทึกข้อมูลสำเร็จ'
                                                })
                                              }
                                            }
                                          })
                                        } else {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                        break;
                                      default :
                                        count++
                                        if (count == this.attachment_data.length - 1) {
                                          this.CheckSubmit = false
                                          this.$swal.fire({
                                            icon: 'success',
                                            title: 'บันทึกข้อมูลสำเร็จ'
                                          })
                                        }
                                        break;
                                    }
                                  })
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  })
                } else {
                  shopData = this.optionsSelect.filter(shop => shop.id == this.shop_type)

                  this.dataFormSubmit.items[0].shop[0].shop_name = this.shop_name
                  this.dataFormSubmit.items[0].shop[0].shop_type_id = shopData[0].id

                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop/request_id/' + this.CardObj.id, this.dataFormSubmit.items[0].shop[0], this.headerAxios).then(resShop => {
                    if (resShop.data.status) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/person/id/' + this.CardObj.person_id, this.dataFormSubmit.items[0].person, this.headerAxios).then(res => {
                        if (res.data.status) {
                          this.contactData.map((element, idxContact) => {
                            switch (element.contact_types_id) {
                              case "1":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.email
                                }, this.headerAxios)
                                break;
                              case "2":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.depart
                                }, this.headerAxios)
                                break;
                              case "3":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.phoneDepart
                                }, this.headerAxios)
                                break;
                              case "4":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.phoneMoblie
                                }, this.headerAxios)
                                break;
                              case "5":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.phoneHome
                                }, this.headerAxios)
                                break;
                              default:
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.address
                                }, this.headerAxios)
                                break;
                            }

                            if (idxContact == this.contactData.length - 1) {
                              this.attachment_data.map((attachmentData) => {
                                switch (attachmentData.attachment_types_id) {
                                  case "1":
                                    if (this.ChkImagePerson) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                        url: this.selectFile
                                      }, this.headerAxios).then(res => {
                                        if (res.data.status) {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                      })
                                    } else {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                    break;
                                  case "2" :
                                    if (this.ChkImagePersonCopy) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                        url: this.selectFile
                                      }, this.headerAxios).then(res => {
                                        if (res.data.status) {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                      })
                                    } else {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                    break;
                                  case "3" :
                                    if (this.ChkImageRecript) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                        url: this.FileRecript
                                      }, this.headerAxios).then(res => {
                                        if (res.data.status) {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                      })
                                    } else {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                    break;
                                  case "4" :
                                    if (this.ChkImageHome) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                        url: this.FileHome
                                      }, this.headerAxios).then(res => {
                                        if (res.data.status) {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                      })
                                    } else {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                    break;
                                  default :
                                    count++
                                    if (count == this.attachment_data.length - 1) {
                                      this.CheckSubmit = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                    }
                                    break;
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  })
                }
              } else {
                this.selectFile = ''
              }
            })
          } else {
            this.dataFormSubmit.items[0].person.citizenId = this.idcard;
            this.dataFormSubmit.items[0].person.firstName = this.nameTh;
            this.dataFormSubmit.items[0].person.lastName = this.surnameTh;
            this.dataFormSubmit.items[0].person.birthdate = this.brithDay
            this.dataFormSubmit.items[0].person.sex = (this.gender == 'ชาย' ? 'M' : 'F');
            this.dataFormSubmit.items[0].person.license_plate = this.vehicleReg;
            this.dataFormSubmit.items[0].person.provinces_id = this.vehicleRegProvice

            if (this.shop_type == '27') {

              shopData = this.optionsSelect.filter(shop => shop.id == this.shop_type)

              this.dataFormSubmit.items[0].shop[0].shop_name = this.shop_name
              this.dataFormSubmit.items[0].shop[0].shop_type_id = shopData[0].id

              this.dataFormSubmit.items[0].adult[0].adult_name = this.adult_name
              this.dataFormSubmit.items[0].adult[0].relationship_id = this.relationship
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop/request_id/' + this.CardObj.id, this.dataFormSubmit.items[0].shop[0], this.headerAxios).then(resShop => {

                if (resShop.data.status) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/adult/request_id/' + this.CardObj.id, this.dataFormSubmit.items[0].adult[0], this.headerAxios).then(resRelation => {
                    if (resRelation.data.status) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/person/id/' + this.CardObj.person_id, this.dataFormSubmit.items[0].person, this.headerAxios).then(res => {
                        if (res.data.status) {
                          this.contactData.map((element, idxContact) => {
                            switch (element.contact_types_id) {
                              case "1":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.email
                                }, this.headerAxios)
                                break;
                              case "2":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.depart
                                }, this.headerAxios)
                                break;
                              case "3":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.phoneDepart
                                }, this.headerAxios)
                                break;
                              case "4":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.phoneMoblie
                                }, this.headerAxios)
                                break;
                              case "5":
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.phoneHome
                                }, this.headerAxios)
                                break;
                              default:
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                                  value: this.$data.address
                                }, this.headerAxios)
                                break;
                            }

                            if (idxContact == this.contactData.length - 1) {
                              this.attachment_data.map((attachmentData) => {
                                switch (attachmentData.attachment_types_id) {
                                  case "1":
                                    count++
                                    if (count == this.attachment_data.length - 1) {
                                      this.CheckSubmit = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                    }
                                    break;
                                  case "2" :
                                    if (this.ChkImagePersonCopy) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                        url: this.FilePersonal
                                      }, this.headerAxios).then(res => {
                                        if (res.data.status) {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                      })
                                    } else {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                    break;
                                  case "3" :
                                    if (this.ChkImageRecript) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                        url: this.FileRecript
                                      }, this.headerAxios).then(res => {
                                        if (res.data.status) {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                      })
                                    } else {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                    break;
                                  case "4" :
                                    if (this.ChkImageHome) {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                        url: this.FileHome
                                      }, this.headerAxios).then(res => {
                                        if (res.data.status) {
                                          count++
                                          if (count == this.attachment_data.length - 1) {
                                            this.CheckSubmit = false
                                            this.$swal.fire({
                                              icon: 'success',
                                              title: 'บันทึกข้อมูลสำเร็จ'
                                            })
                                          }
                                        }
                                      })
                                    } else {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                    break;
                                  default :
                                    count++
                                    if (count == this.attachment_data.length - 1) {
                                      this.CheckSubmit = false
                                      this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ'
                                      })
                                    }
                                    break;
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  })
                }
              })
            } else {

              shopData = this.optionsSelect.filter(shop => shop.id == this.shop_type)

              this.dataFormSubmit.items[0].shop[0].shop_name = this.shopName
              this.dataFormSubmit.items[0].shop[0].shop_type_id = shopData[0].id

              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/shop/request_id/' + this.CardObj.id, this.dataFormSubmit.items[0].shop[0], this.headerAxios).then(resShop => {
                if (resShop.data.status) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/person/id/' + this.CardObj.person_id, this.dataFormSubmit.items[0].person, this.headerAxios).then(res => {
                    if (res.data.status) {
                      this.contactData.map((element, idxContact) => {
                        switch (element.contact_types_id) {
                          case "1":
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                              value: this.$data.email
                            }, this.headerAxios)
                            break;
                          case "2":
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                              value: this.$data.depart
                            }, this.headerAxios)
                            break;
                          case "3":
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                              value: this.$data.phoneDepart
                            }, this.headerAxios)
                            break;
                          case "4":
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                              value: this.$data.phoneMoblie
                            }, this.headerAxios)
                            break;
                          case "5":
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                              value: this.$data.phoneHome
                            }, this.headerAxios)
                            break;
                          default:
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/contact/id/' + element.id, {
                              value: this.$data.address
                            }, this.headerAxios)
                            break;
                        }

                        if (idxContact == this.contactData.length - 1) {
                          this.attachment_data.map((attachmentData) => {
                            switch (attachmentData.attachment_types_id) {
                              case "1":
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                                break;
                              case "2" :
                                if (this.ChkImagePersonCopy) {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                    url: this.FilePersonal
                                  }, this.headerAxios).then(res => {
                                    if (res.data.status) {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                  })
                                } else {
                                  count++
                                  if (count == this.attachment_data.length - 1) {
                                    this.CheckSubmit = false
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                  }
                                }
                                break;
                              case "3" :
                                if (this.ChkImageRecript) {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                    url: this.FileRecript
                                  }, this.headerAxios).then(res => {
                                    if (res.data.status) {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                  })
                                } else {
                                  count++
                                  if (count == this.attachment_data.length - 1) {
                                    this.CheckSubmit = false
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                  }
                                }
                                break;
                              case "4" :
                                if (this.ChkImageHome) {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/attachment/id/' + attachmentData.id, {
                                    url: this.FileHome
                                  }, this.headerAxios).then(res => {
                                    if (res.data.status) {
                                      count++
                                      if (count == this.attachment_data.length - 1) {
                                        this.CheckSubmit = false
                                        this.$swal.fire({
                                          icon: 'success',
                                          title: 'บันทึกข้อมูลสำเร็จ'
                                        })
                                      }
                                    }
                                  })
                                } else {
                                  count++
                                  if (count == this.attachment_data.length - 1) {
                                    this.CheckSubmit = false
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'บันทึกข้อมูลสำเร็จ'
                                    })
                                  }
                                }
                                break;
                              default :
                                count++
                                if (count == this.attachment_data.length - 1) {
                                  this.CheckSubmit = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                }
                                break;
                            }
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          }
        }
      }

    },
    EditImagePerson: function () {

    },
    ChooseCardType2: function () {
      if (this.rowsBackup2.length == 0) {
        this.rowsBackup2 = this.rows
      }
      if (this.rdoCardType2 != '*') {
        this.rows = this.rowsBackup2.filter(item => item.status_id == this.rdoCardType2)
      } else {
        this.rows = this.rowsBackup2
        this.rowsBackup2 = []
      }
    },
    ChooseCardType: function () {
      this.rowsBackup2 = []
      if (this.rowsBackup.length == 0) {
        this.rowsBackup = this.rows
      }
      if (this.rdoCardType != '0') {
        this.rows = this.rowsBackup.filter(item => item.request_types_id == this.rdoCardType)
        this.CountTypeSec0 = this.rows.filter(item => item.status_id == '0')
        this.CountTypeSec2 = this.rows.filter(item => item.status_id == '2')
        this.CountTypeSec3 = this.rows.filter(item => item.status_id == '3')
        this.CountTypeSec4 = this.rows.filter(item => item.status_id == '4')
        this.CountTypeSec5 = this.rows.filter(item => item.status_id == '5')
        this.CountTypeSec6 = this.rows.filter(item => item.status_id == '6')
        this.ChooseCardType2()
      } else {
        this.rows = this.rowsBackup
        this.rowsBackup = []
      }
    },
    FileSelectPersonal: function (event) {
      this.ImagePersonCopy = ''
      if (event.target.files[0]) {
        var Checkfile = false;
        switch (event.target.files[0].name.split('.')[1]) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            this.ImagePersonCopyType = true
            this.pdfPersonCopyType = false
            this.ImagePersonCopy = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          case 'pdf':
            this.pdfPersonCopyType = true
            this.ImagePersonCopyType = false
            this.ImagePersonCopy = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.ImagePersonCopyType = false
            this.pdfPersonCopyType = false
            this.ImagePersonCopy = ''
            break
        }
        if (Checkfile) {

          if (event.target.files[0].size > 4096 * 4096) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
            })
            this.ImagePersonCopyType = false
            this.pdfPersonCopyType = false
            this.ImagePersonCopy = ''
          } else {

            const fd = new FormData()
            fd.append('file', event.target.files[0], event.target.files[0].name)
            this.headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, this.headerAxios).then(res => {
              if (res.data.status) {
                this.FilePersonal = res.data.path
              } else {
                this.FilePersonal = ''
              }
            })
          }

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + event.target.files[0].name.split('.')[1]
          })
        }


      } else {
        this.ImagePersonCopyType = false
        this.pdfPersonCopyType = false
        this.ImagePersonCopy = ''
        this.FilePersonal = ''
      }
    },
    FileSelectRecript: function (event) {
      this.ImageRecript = ''
      if (event.target.files[0]) {
        var Checkfile = false;
        switch (event.target.files[0].name.split('.')[1]) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            this.ImageRecriptType = true
            this.pdfRecriptType = false
            this.ImageRecript = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          case 'pdf':
            this.pdfRecriptType = true
            this.ImageRecriptType = false
            this.ImageRecript = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.ImageRecriptType = false
            this.pdfRecriptType = false
            this.ImageRecript = ''
            break
        }
        if (Checkfile) {
          if (event.target.files[0].size > 4096 * 4096) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
            })
            this.ImageRecriptType = false
            this.pdfRecriptType = false
            this.ImageRecript = ''
          } else {
            const fd = new FormData()
            fd.append('file', event.target.files[0], event.target.files[0].name)
            this.headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, this.headerAxios).then(res => {
              if (res.data.status) {
                this.FileRecript = res.data.path
              } else {
                this.FileRecript = ''
              }
            })
          }

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + event.target.files[0].name.split('.')[1]
          })
        }

      } else {
        this.ImageRecriptType = false
        this.pdfRecriptType = false
        this.ImageRecript = ''
        this.FileRecript = ''
      }
    },
    FileSelectHome: function (event) {

      if (event.target.files[0]) {
        var Checkfile = false;
        switch (event.target.files[0].name.split('.')[1]) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            this.ImageHomeType = true
            this.pdfHomeType = false
            this.ImageHome = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          case 'pdf':
            this.pdfHomeType = true
            this.ImageHomeType = false
            this.ImageHome = URL.createObjectURL(event.target.files[0])
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.ImageHomeType = false
            this.pdfHomeType = false
            this.ImageHome = ''
            break
        }
        if (Checkfile) {
          if (event.target.files[0].size > 4096 * 4096) {
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด',
              text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
            })
            this.ImageHomeType = false
            this.pdfHomeType = false
            this.ImageHome = ''
          } else {

            const fd = new FormData()
            fd.append('file', event.target.files[0], event.target.files[0].name)
            this.headerAxios = {
              headers: {
                'Content-Type': 'multipart/form-data',
                'WithCredentials': true,
                "Access-Control-Allow-Origin": "*"
                // "Accept": 'multipart/form-data'
              }
            }

            axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, this.headerAxios).then(res => {
              if (res.data.status) {
                this.FileHome = res.data.path
              } else {
                this.FileHome = ''
              }
            })
          }

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + event.target.files[0].name.split('.')[1]
          })
        }

      } else {
        this.ImageHomeType = false
        this.pdfHomeType = false
        this.ImageHome = ''
        this.FileHome = ''
      }
    },
    onFileSelected: function (event) {
      this.selectFile = ''
      if (event.target.files[0]) {
        var Checkfile = false;
        switch (event.target.files[0].name.split('.')[1]) {
          case 'jpg':
          case 'jpeg':
          case 'gif':
          case 'bmp':
          case 'png':
            Checkfile = true;
            break
          default:
            Checkfile = false;
            this.pic_Profile = require('@/assets/img/NonPic.png')
            break
        }
        if (Checkfile) {
          /*if (event.target.files[0].size > 4096 * 4096) {
              this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'ไม่สนับสนุนไฟล์เกิน 4 mb'
              })
              this.selectFile = ''
          } else {*/
          if (event.target.files[0]) {
            this.url = URL.createObjectURL(event.target.files[0])
            this.pic_Profile = this.url
            // this.pic_Profile = require('@/assets/img/ShowfPict.jpg')
          } else {
            this.pic_Profile = require('@/assets/img/NonPic.png')
          }

          this.selectFile = event.target.files[0].name
          /*}*/

        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ระบบไม่สนับสนุนนามสกุลไฟล์ ' + event.target.files[0].name.split('.')[1]
          })
        }

      } else {
        this.selectFile = ''
        this.pic_Profile = require('@/assets/img/NonPic.png')
      }
    },
    onUpload: function (dataFile) {
      const fd = new FormData()
      fd.append('file', dataFile, dataFile.name)
      this.headerAxios = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'WithCredentials': true,
          "Access-Control-Allow-Origin": "*"
          // "Accept": 'multipart/form-data'
        }
      }

      axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, this.headerAxios).then(res => {
        if (res.data.status) {
          return res.data.path
        } else {
          return null
        }
      })
    },
    parseJwt: function (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }
  },
  mounted() {
    axios.post(ConstData.ConnectionHost + '/saveSessions.php',  queryString.stringify({
      session: 'https://medhr.medicine.psu.ac.th/CardRegister/#/ManageCardPP3S'
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    if (this.$cookies.get('access_token')) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
      this.initFunc()
    } else {
      // this.$cookies.set('access_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwZXJpZCI6IjQ2NzkyIiwibmFtZSI6Ilx1MGUxOFx1MGUyN1x1MGUzMVx1MGUwYVx1MGUwYVx1MGUzMVx1MGUyMiIsInN1cm5hbWUiOiJcdTBlMDhcdTBlMzFcdTBlMTlcdTBlMTdcdTBlMjNcdTBlMTdcdTBlMzRcdTBlMWVcdTBlMjJcdTBlNGMifQ.YTW8R5wDrEPUPv5HkvfewbiQKBwpF18o5ZBxwZPtk1o')

      this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/ManageCardPP3S')
      this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/ManageCardPP3S')
      window.location.href = ConstData.ConnectionHost + '/SingleSign/';
    }
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade2-enter-active {
  transition: all .5s ease;
}

.slide-fade2-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade2-enter, .slide-fade2-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateY(10px);
  opacity: 0;
}

.v-data-table th {
  font-size: 16px;
}

.v-data-table td {
  font-size: 14px;
}
</style>
